import { useEffect, useState,useContext } from 'react';
import './ProjectBooking.css';
import {Context} from '../Context';
import LoadingSpinner from '../Components/LoadingSpinner';
import newProjectBookingDataService from '../Services/ProjectBookingService';
import CustomerSelector from '../Customers/CustomerSelector';
import { FaDotCircle } from "react-icons/fa";
import { MdError  } from "react-icons/md";
import { HiBadgeCheck } from "react-icons/hi";
import { IoIosAlert } from "react-icons/io";
import moment from 'moment';

import AddressInputField from '../Inputs/AddressInputField';
import StandardInputField from '../Inputs/StandardInputField';
import DollarInputField from '../Inputs/DollarInputField';
import PercentageInputField from '../Inputs/PercentageInputField';
import { count } from 'd3';

const serverPath = 'https://www.cornerstoneinc.io/'

const branchOptions = [
    {text:'02 - DEC Construction', value:'02'},
    {text:'04 - Electronics', value:'04'},
    {text:'06 - C3 Mattresses', value:'06'},
    {text:'07 - Airteq Locks', value:'07'},
    {text:'09 - Modular Construction', value:'09'},
    {text:'12 - Service North', value:'12'},
    {text:'61 - Service East', value:'61'},
    {text:'62 - Service Southwest', value:'62'},
    {text:'64 - Service Southeast', value:'64'},
    {text:'66 - Service South', value:'66'},
];

const billingOptions = [
    {text:'Annual', value:'upfront'},
    {text:'On Visits', value:'onVisit'},
    {text:'Monthly', value:'monthly'},
    {text:'Quarterly', value:'quarterly'},
    {text:'Semiannual', value:'semiannual'}
];

const insuranceProgramOptions = [
    {text: 'Contractor Controlled Insurance Program', value: 'CCIP'},
    {text: 'Owner Controlled Insurance Program', value: 'OCIP'},
    {text: 'None', value: null}
];

const taxabilityOptions = [
    {text:'Customer Taxed', value:'Customer'},
    {text:'Contractor Taxed',value:'Contractor'},
    {text:'Exempt',value:'Exempt'},
    {text:'Other',value:'Other'},
];

const requestTypeOptions = [
    {text:'Project', value:'Project'},
    {text:'Service Contract',value:'Service'}
];

const serviceBudgetUnits = [
    {text:'Hour', value:'HOUR'},
    {text:'Lump Sum', value:'LS'}
]

//  - - - - - - - - - - - API SUPPORT CALLS - - - - - - - - - - -
const sendProjectBudget = async (apiToken, budgetImport, filename, setBudgetResponse, setBudgetError) => {
    newProjectBookingDataService.uploadBudget(apiToken,budgetImport[0],filename)
    .then(response =>{
        console.log('Project Budget Response', response.data);
        setBudgetResponse(response.data);
    }).catch( e=> {
        setBudgetError(e.toString());

    });
};

const sendServiceBudget = async (apiToken, serviceBudgetImport, filename, setServiceBudgetResponse, setServiceBudgetError) => {
    newProjectBookingDataService.uploadServiceBudget(apiToken,serviceBudgetImport[0],filename)
    .then(response =>{
        setServiceBudgetResponse(response.data);
    }).catch( e=> {
        setServiceBudgetError(e.toString());
    });
};

const getBudgetTemplate = async () => {
    newProjectBookingDataService.getBlankTemplate()
};

const getFilteredCostCodeList = async (apiToken, costCode, setCostCodeList) => {
    newProjectBookingDataService.getFilteredCostCodeList(apiToken,costCode)
    .then(response =>{
        setCostCodeList(response.data.responseArray);
    }).catch( e=> {
        console.log(e.toString());
    });
};

const getFilteredProjectManagers = async (apiToken,branch,setProjectManagerList,setProjectManagerError) => {
    newProjectBookingDataService.getFilteredProjectManagerList(apiToken,branch)
    .then(response =>{
        if(response.data.length > 0){
            let projectManagerOptions = [];
            response.data.forEach(element => {
                const tempPM = {text: `${element.id} - ${element.name} - ${element.email}`, value: element.id}
                projectManagerOptions.push(tempPM);
            });
            setProjectManagerList(projectManagerOptions);
        }
        else{
            setProjectManagerList([{text:'No Project Managers Listed', value:null},]);
        }

    }).catch( e=> {
        setProjectManagerError(e.toString());
    });
};

const sendContractFile = async (apiToken,file,filename,setContractSuccess,setContractError) => {
    newProjectBookingDataService.postContract(apiToken,file,filename)
    .then(response =>{
        setContractSuccess(response.data.id);
    }).catch( e => {
        setContractError('Server Failed to Upload Contract Document. Please Contact IT for support.');
    });
};

const sendPrevailingWageFile = async (apiToken,file,filename,setPrevailingWageSuccess,setPrevailiingWageError) => {
    newProjectBookingDataService.postPrevailingWage(apiToken,file,filename)
    .then(response =>{
        setPrevailingWageSuccess(response.data.id);
    }).catch( e=> {
        setPrevailiingWageError('Server Failed to Upload Certified Payroll / Prevailing Wage Document. Please Contact IT for support.');
    });
};

const sendBondFile = async (apiToken,file,filename,setBondSuccess,setBondError) => {
    newProjectBookingDataService.postBond(apiToken,file,filename)
    .then(response =>{
        setBondSuccess(response.data.id);
    }).catch( e => {
        setBondError('Server Failed to Upload Bonding Document. Please Contact IT for support.');
    });
};

const sendTaxExemptFile = async (apiToken,file,filename,setTaxExemptSuccess,setTaxExemptError) => {
    newProjectBookingDataService.postTaxExempt(apiToken,file,filename)
    .then(response =>{
        setTaxExemptSuccess(response.data.id);
    }).catch( e=> {
        setTaxExemptError('Server Failed to Upload Tax Exemption Document. Please Contact IT for support.');
    });
};

const sendCertificateFile = async (apiToken,file,filename,setCertificateSuccess,setCertificateError) => {
    newProjectBookingDataService.postCertificate(apiToken,file,filename)
    .then(response =>{
        setCertificateSuccess(response.data.id);
    }).catch( e=> {
        setCertificateError('Server Failed to Upload OCIP / CCIP Document. Please Contact IT for support.');
    });
};

const sendFinancialTabFile = async (apiToken,file,filename,setFinancialTabSuccess,setFinancialTabError) => {
    newProjectBookingDataService.postFinancialTab(apiToken,file,filename)
    .then(response =>{
        setFinancialTabSuccess(response.data.id);
    }).catch( e=> {
        setFinancialTabError('Server Failed to Upload Financial Tab Document. Please Contact IT for support.');
    });
};

const sendProjectBookingRequest = async (apiToken,projectBookingObject,setProjectBookingSuccess,setProjectBookingError) => {
    console.log('Sending Project Booking Request', projectBookingObject);
    newProjectBookingDataService.submitProjectBookingRequest(apiToken,projectBookingObject)
    .then(response =>{
        setProjectBookingSuccess(response.data.id);
    }).catch( e=> {
        setProjectBookingError('Server Failed to Upload Project Booking Request. Please Contact IT for support.');
    });
};

const updateProjectBookingRequest = async (apiToken,projectBookingObject,setProjectBookingSuccess,setProjectBookingError) => {
    newProjectBookingDataService.updateProjectBookingRequest(apiToken,projectBookingObject)
    .then(response =>{
        setProjectBookingSuccess(response.data.id);
    }).catch( e=> {
        setProjectBookingError('Server Failed to Upload Project Booking Request. Please Contact IT for support.');
    });
};

const sendTaskFile = async (apiToken,taskFile,projectName,setTaskFileSuccess,setTaskFileError) => {
    newProjectBookingDataService.updateProjectBookingTask(apiToken,taskFile,projectName)
    .then(response =>{
        setTaskFileSuccess(response.data.fileName);
    }).catch( e=> {
        setTaskFileError('Server Failed to Upload Task File Document. Please Contact IT for support.');
    });
};

const sendRevenueFile = async (apiToken,revenueFile,projectName,setRevenueFileSuccess,setRevenueFileError) => {
    newProjectBookingDataService.updateProjectBookingRevenue(apiToken,revenueFile,projectName)
    .then(response =>{
        setRevenueFileSuccess(response.data.fileName);
    }).catch( e=> {
        setRevenueFileError('Server Failed to Upload Revenue File Document. Please Contact IT for support.');
    });
};

const sendCostFile = async (apiToken,costFile,projectName,setCostFileSuccess,setCostFileError) => {
    newProjectBookingDataService.updateProjectBookingCost(apiToken,costFile,projectName)
    .then(response =>{
        setCostFileSuccess(response.data.fileName);
    }).catch( e=> {
        setCostFileError('Server Failed to Upload Cost File Document. Please Contact IT for support.');
    });
};

const getServiceContracts = async (apiToken,projectId,setServiceContracts,setServiceContractsError) => {
    newProjectBookingDataService.getServiceContracts(apiToken,projectId)
    .then(response =>{
        console.log('Service Contracts Response', response.data);
        if(response.data.serviceContracts.length > 0){
            setServiceContracts(response.data.serviceContracts);
            return response.data.serviceContracts;
        }
        else{
            return null;
        }

    }).catch( e=> {
        setServiceContractsError(e.toString());
    });
};

const createServiceContractTemplate = async (apiToken,serviceContractList,setToFunction) => {
    newProjectBookingDataService.postServiceContractTemplate(apiToken,serviceContractList)
    .then(response =>{
        if(response.status > 199 && response.status < 300){
            setToFunction(response.data.serviceCostTemplate);
            const newWindow = window.open(`${serverPath+response.data.serviceCostTemplate}`, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
        }
        else{
            return null;
        }

    }).catch( e=> {
        console.log(e.toString());
    });
};

const sendServiceCostFile = async (apiToken,serviceCostFile,projectName,setServiceTaskFilename,setServiceRevenueFilename,setServiceCostFilename,setServiceFilesComplete,serviceContractList,setServiceCostFileError) => {
    newProjectBookingDataService.postServiceCostFile(apiToken,serviceCostFile,serviceContractList,projectName)
    .then(response => {
        setServiceTaskFilename(response.data.taskFilename);
        setServiceRevenueFilename(response.data.revenueFilename);
        setServiceCostFilename(response.data.costFilename);
        setServiceFilesComplete(true);
    }).catch( e=> {
        setServiceCostFileError('Server Failed to Upload Service Budget. Please Contact IT for support.');
    });
};

//  - - - - - - - - - - - HELPER FUNCTIONS - - - - - - - - - - -
const getDate = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    
    today = mm + '.' + dd + '.' + yyyy;
    return today;
};

const organizeDate = (date) => {
    return moment(date).format("MMM Do YYYY");
};

const organizeInputDate = (date) => {
    return moment(date).format("YYYY-MM-DD");
};

const removeArrayItem = (array, index) => { 
    if (index > -1) {
        array.splice(index,1);
    }
    return array;
};

const numberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const usdFormatter = (value) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    return formatter.format(value);
};



//  - - - - - - - - - - - OLD BUDGET COMPONENTS - - - - - - - - - - -
/*
const ColumnComponent = ({title, value, setTo, editing, width, codeList, setTitle, options}) => {
    const [match, setMatch] = useState(false);

    const cssProps = {
        '--columnWidth': `${width}px`
    };

    useEffect(() => {
        setMatch(false);

        if(codeList){
            codeList.forEach(element => {
                if(element.costCode === value){
                    setMatch(true);
                    setTo(value);
                    setTitle(element.title);
                }
            });
        };
    },[value]);

    return (
        <>
        {   !editing && title !== 'Cost' &&
            <div className='Project-Booking-Budget-Line-Column' style={cssProps}>
                {value}
            </div>
        }
        {   !editing && title === 'Cost' &&
            <div className='Project-Booking-Budget-Line-Column' style={cssProps}>
                {`$${numberWithCommas(value)}`}
            </div>
        }
        {   editing &&
        <div className='Project-Booking-Budget-Line-Column-Edit'>
            {   !options &&
                <input className='Project-Booking-Budget-Line-Column' value={value} onChange={e => setTo(e.target.value)} style={cssProps}/>
            }
            {   options &&
                <select className='Project-Booking-Budget-Line-Column' value={value} style={cssProps} onChange={e => setTo(e.target.value)}>
                    {   
                        options.map((element, key) => (
                            <option key={key} value={element.value}>{element.text}</option>
                        ))
                    }
                </select>
            }
            {   codeList &&
                <div className='Project-Booking-Budget-Line-CC-List'>
                    {   codeList && !match &&
                    codeList.map((element,key) => (
                        <div className='Project-Booking-Budget-Line-CC-List-Item' key={key} onClick={() => {setTo(element.costCode); setTitle(element.title)}}>
                            {`${element.costCode} - ${element.title}`}
                        </div>
                    ))
                    }
                </div>
            }
        </div>
        
        }
        </>
    )
};

const BudgetControlComponent = ({hovering, expanded, setExpanded }) => {
    return(
        <div className='Project-Booking-Budget-Line-Control'>
            {   !expanded && hovering &&
            <div className='Project-Booking-Budget-Line-Button' onClick={() => setExpanded(true)}>
                <MdExpandMore className='Project-Booking-Budget-Line-Button-Icon'/>
            </div>
            }
            {   expanded &&
            <div className='Project-Booking-Budget-Line-Button' onClick={() => setExpanded(false)}>
                <MdExpandLess  className='Project-Booking-Budget-Line-Button-Icon'/>
            </div>
            }
        </div>
    )
};

const EstimateControlComponent = ({editing, hovering, setEditing, deleteLine, submitChanges}) => {
    return(
        <div className='Project-Booking-Budget-Line-Control'>
            {   !editing && hovering &&
            <div className='Project-Booking-Budget-Line-Button' onClick={() => setEditing(true)}>
                <MdOutlineEdit className='Project-Booking-Budget-Line-Button-SM-Icon'/>
            </div>
            }
            {   editing &&
            <>
                <div className='Project-Booking-Budget-Line-Button'>
                    <TiCancel className='Project-Booking-Budget-Line-Button-SM-Icon Icon-Cancel' onClick={() => deleteLine()}/>
                </div>

                <div className='Project-Booking-Budget-Line-Button'>
                    <FaCheck className='Project-Booking-Budget-Line-Button-SM-Icon Icon-Approve' onClick={() => submitChanges()}/>
                </div>
            </>
            }
        </div>
    )
};

const BudgetLine = ({costCode='', title='', index=null, description, group, total, estimateItemArray,updateBudgetLine,deleteEstimateItem}) => {
    const [lineCostCode, setCostCode] = useState(costCode);
    const [lineTitle, setTitle] = useState(title);  
    const [accountGroup, setGroup] = useState(group);
    const [lineTotal, setTotal] = useState(total);
    const [expanded, setExpanded ] = useState(false);
    const [backgroundColor, setBackgroundColor] = useState('');

    const [hovering, setHovering] = useState();

    const cssProps = {
    '--backgroundColor':backgroundColor
    }

    useEffect(() => {
        if(expanded) setBackgroundColor('rgb(204, 204, 204)');
        else setBackgroundColor('');
    },[expanded]);

    return(
        <>
        <div className='Project-Booking-Budget-Line' style={cssProps} onMouseOver={() => setHovering(true)} onMouseOut={() => setHovering(false)} onClick={() => setExpanded(!expanded)}>
            <ColumnComponent title={'Cost Code'} value={lineCostCode} setTo={setCostCode} width={100}/>
            <ColumnComponent title={'Code Title'} value={lineTitle} width={350}/>
            <ColumnComponent title={'Account Group'} value={accountGroup} setTo={setGroup} width={120}/>
            <ColumnComponent title={'Cost'} value={`${parseFloat(lineTotal).toFixed(2)}`} setTo={setTotal} width={100}/>
            <BudgetControlComponent hovering={hovering} expanded={expanded} setExpanded={setExpanded}/>
        </div>
        {   expanded &&
            estimateItemArray.map((element,key) => (
                <EstimateLineItem key={key} costCode={costCode} index={key} description={element.description} group={element.group} total={element.total} updateBudgetLine={updateBudgetLine} deleteEstimateItem={deleteEstimateItem}/>
            ))
        }
        </>
    )
};

const EstimateLineItem = ({costCode='', title='', index=null, description, group, total, assignBudgetLine, updateBudgetLine, deleteEstimateItem}) => {
    const contextObject = useContext(Context);

    const [editing, setEditing] = useState(false);
    const [lineCostCode, setCostCode] = useState(costCode);
    const [lineTitle, setTitle] = useState(title);  
    const [lineDescription, setDescription] = useState(description);
    const [accountGroup, setGroup] = useState(group);
    const [lineTotal, setTotal] = useState(total);

    const [costCodeList, setCostCodeList] = useState([]);
    const [hovering, setHovering] = useState();

    const ccsProps = {
        '--backgroundColor' : 'rgb(220, 220, 220)',
    };

    const resetFields = () => {
        setCostCodeList([]);
        setCostCode(costCode);
        setTitle(title);
        setDescription(description);
        setGroup(group);
        setTotal(total);
    };

    useEffect(() => {
        setCostCodeList([]);
    },[lineTitle]);

    useEffect(() => {
        resetFields();
    },[costCode,title,description,group,total]);

    useEffect(() => {
        if(lineCostCode) getFilteredCostCodeList(contextObject.apiToken,lineCostCode,setCostCodeList);
    },[lineCostCode]);

    const submitChanges = () => {
        setEditing(false);
        if(costCode === lineCostCode && group === accountGroup && total === lineTotal){
            // Nothing Changed
        }
        else{
            if(assignBudgetLine) assignBudgetLine(index,lineCostCode,lineDescription,accountGroup,lineTitle,lineTotal);
            else updateBudgetLine(index,costCode,group,total,lineCostCode,lineDescription,accountGroup,lineTitle,lineTotal)
        };
    };

    const deleteLine = () => {
        setEditing(false);
        deleteEstimateItem(costCode,group,index,total);
    };

    return(
        <div className='Project-Booking-Budget-Line' onMouseOver={() => setHovering(true)} onMouseOut={() => setHovering(false)} style={ccsProps}>
            {   !editing &&
                <ColumnComponent title={'Space'} value={''} width={100}/>
            }
            {   editing &&
                <ColumnComponent title={'Cost Code'} value={lineCostCode} setTo={setCostCode} editing={editing} width={90} codeList={costCodeList} setTitle={setTitle}/>
            }
            {   !editing &&
                <ColumnComponent title={'Description'} value={lineDescription} setTo={setDescription} editing={editing} width={350}/>
            }
            {   editing &&
                <ColumnComponent title={'Description'} value={lineDescription} setTo={setDescription} editing={editing} width={342}/>
            }
            {   !editing &&
                <ColumnComponent title={'Account Group'} value={accountGroup} setTo={setGroup} editing={editing} width={120}/>
            }
            {   editing &&
                <ColumnComponent title={'Account Group'} value={accountGroup} setTo={setGroup} editing={editing} width={115} options={[{text:'M',value:'M'},{text:'L',value:'L'},{text:'S',value:'S'},{text:'E',value:'E'},{text:'O',value:'O'}]}/>
            }
            <ColumnComponent title={'Cost'} value={`${lineTotal}`} setTo={setTotal} editing={editing} width={100}/>
            <EstimateControlComponent editing={editing} hovering={hovering} setEditing={setEditing} deleteLine={deleteLine} submitChanges={submitChanges}/>
        </div>
    );
};

const ProjectBudgetForm = ({formattedBudget, assignBudgetLine, updateBudgetLine, setTaxesFound, setPerDiemFound, setBondFound, deleteEstimateItem}) => {
    return(
        <div className='Project-Booking-Budget-Form'> 
            {
            Object.keys(formattedBudget).map((identifier,key) => {
                if(identifier != 'unassigned') {
                    if(formattedBudget[identifier].costCode === taxesCode || formattedBudget[identifier].costCode === useTaxCode || formattedBudget[identifier].costCode === salesTaxCode) setTaxesFound(true);
                    if(formattedBudget[identifier].costCode === perDiemCode) setPerDiemFound(true);
                    if(formattedBudget[identifier].costCode === bondCode) setBondFound(true);
                    
                    return(
                        <BudgetLine key={key} title={formattedBudget[identifier].title} costCode={formattedBudget[identifier].costCode} group={formattedBudget[identifier].group} total={formattedBudget[identifier].total} estimateItemArray={formattedBudget[identifier].estimateItemArray} updateBudgetLine={updateBudgetLine} deleteEstimateItem={deleteEstimateItem}/>
                    )
                };
            })
            }

            {   formattedBudget.unassigned.length > 0 &&
                <div className='Project-Booking-Budget-Section-Title'>Needs Assigned</div>
            }
            { formattedBudget.unassigned.length > 0 &&
            formattedBudget.unassigned.map((element,key) => (
                <EstimateLineItem key={key} index={key} description={element.description} group={element.group} total={element.total} assignBudgetLine={assignBudgetLine} deleteEstimateItem={deleteEstimateItem}/>
            ))
            }

            {

            }
        </div>
    )
};

const TotalsBar = ({materialTotal,laborTotal,subcontractorTotal,equipmentTotal,otherTotal,totalBudget}) => {
    return(
        <div className='Project-Booking-Budget-Totals'>
            <div className='Project-Booking-Budget-Totals-Item'>
                {`Materials $${materialTotal}`}
            </div>
            <div className='Project-Booking-Budget-Totals-Item'>
                {`Labor $${laborTotal}`}
            </div>
            <div className='Project-Booking-Budget-Totals-Item'>
                {`Subcontractors $${subcontractorTotal}`}
            </div>
            <div className='Project-Booking-Budget-Totals-Item'>
                {`Equipment $${equipmentTotal}`}
            </div>
            <div className='Project-Booking-Budget-Totals-Item'>
                {`Other $${otherTotal}`}
            </div>
            <div className='Project-Booking-Budget-Totals-Item'>
                {`Total Budget $${totalBudget}`}
            </div>
        </div>
    )
};

const [updating, setUpdating] = useState(false);
const [newEstimateItem, setNewEstimateItem] = useState(false);
const [taxesFound, setTaxesFound] = useState(false);
const [perDiemFound, setPerDiemFound] = useState(false);
const [bondFound, setBondFound] = useState(false);
const [materialTotal, setMaterialTotal] = useState(0);
const [laborTotal, setLaborTotal] = useState(0);
const [equipmentTotal, setEquipmentTotal] = useState(0);
const [subcontractorTotal, setSubcontractorTotal] = useState(0);
const [otherTotal, setOtherTotal] = useState(0);
const [totalBudget, setTotalBudget] = useState(0);
const [taxError, setTaxError] = useState('');

// Assigns an unassigned estimate item
const assignBudgetLine = (index,costCode,description,group,title,total) => {
    let newFormattedBudget = formattedBudget;

    refreshForms();

    if(index >= 0){
        const newUnassignedArray = removeArrayItem(formattedBudget.unassigned,index);
        newFormattedBudget.unassigned = newUnassignedArray;
    }
    else{
        setNewEstimateItem(false);
    }

    const budgetKey = `${costCode}${group}`;

    let updated = false;
    for (const [key, value] of Object.entries(newFormattedBudget)) {
        if(key == budgetKey) {
            const newEstimateItem = {description:description, group:group, total:total};
            newFormattedBudget[budgetKey].estimateItemArray.push(newEstimateItem);
            const newTotal = parseFloat(newFormattedBudget[budgetKey].total) + parseFloat(total);
            newFormattedBudget[budgetKey].total = newTotal.toFixed(2);
            updated = true;
            break;
        };
    };

    if(!updated){
        const newEstimateItem = {description:description, group:group, total:total};
        newFormattedBudget[budgetKey] = {costCode:costCode, estimateItemArray:[newEstimateItem,], group:group, title:title, total:parseFloat(total)}
    };
    setFormattedBudget(newFormattedBudget);

    setTimeout(() => {
        updateTotals();
    },100);
};

// Updates an already assigned estimate item
const updateBudgetLine = (index,originalCode,originalGroup,oldTotal,costCode,description,group,title,total) => {
    let newFormattedBudget = formattedBudget;

    refreshForms();

    // Remove from the existing Item Array
    const oldKey = `${originalCode}${originalGroup}`;
    const newEstimateItemArray = removeArrayItem(formattedBudget[oldKey].estimateItemArray,index);
    newFormattedBudget[oldKey].estimateItemArray = newEstimateItemArray;

    // Subtract from Total
    const newTotal = newFormattedBudget[oldKey].total - parseFloat(oldTotal);
    newFormattedBudget[oldKey].total = newTotal.toFixed(2);

    if(!newTotal > 0){
        delete newFormattedBudget[oldKey]
    }

    // Add to New Code 
    const newKey = `${costCode}${group}`;
    let updated = false;
    for (const [key, value] of Object.entries(newFormattedBudget)) {
        if(key == newKey) {
            const newEstimateItem = {description:description, group:group, total:total};
            newFormattedBudget[newKey].estimateItemArray.push(newEstimateItem);
            const newTotal = parseFloat(newFormattedBudget[newKey].total) + parseFloat(total);
            newFormattedBudget[newKey].total = newTotal.toFixed(2);
            updated = true;
            break;
        };
    };

    if(!updated){
        const newEstimateItem = {description:description, group:group, total:total};
        newFormattedBudget[newKey] = {costCode:costCode, estimateItemArray:[newEstimateItem,], group:group, title:title, total:total}
    };

    setFormattedBudget(newFormattedBudget);

    setTimeout(() => {
        updateTotals();
    },100);
};

// Deletes an estimate item
const deleteEstimateItem = (costCode,group,index,total) => {
    if(index === -1){
        setNewEstimateItem(false);
    }
    else{
        let newFormattedBudget = formattedBudget;

        refreshForms();

        if(!costCode){
            const newUnassignedArray = removeArrayItem(formattedBudget.unassigned,index);
            newFormattedBudget.unassigned = newUnassignedArray;
        }
        else{
            // Remove from the existing Item Array
            const oldKey = `${costCode}${group}`;
            const newEstimateItemArray = removeArrayItem(formattedBudget[oldKey].estimateItemArray,index);
            newFormattedBudget[oldKey].estimateItemArray = newEstimateItemArray;

            // Subtract from Total
            const newTotal = newFormattedBudget[oldKey].total - parseFloat(total);
            newFormattedBudget[oldKey].total = newTotal.toFixed(2);

            if(!newTotal > 0){
                delete newFormattedBudget[oldKey]
            };
        };

        setFormattedBudget(newFormattedBudget);

        setTimeout(() => {
            updateTotals();
        },100);
    };
};


    // Refreshes Budget by setting updating to true temporary
    const refreshForms = () => {
        setUpdating(true);

        setTimeout(() => {
            setUpdating(false);
        },100);
    };

    // Updates the totals
    const updateTotals = () => {
        let tempMaterial = 0;
        let tempLabor = 0;
        let tempEquipment = 0;
        let tempSubcontractor = 0;
        let tempOther = 0;

        Object.keys(formattedBudget).map((identifier,key)=> {
            if(formattedBudget[identifier].group === 'M') tempMaterial += parseFloat((formattedBudget[identifier].total));
            else if(formattedBudget[identifier].group === 'L') tempLabor += parseFloat((formattedBudget[identifier].total));
            else if(formattedBudget[identifier].group === 'E') tempEquipment += parseFloat((formattedBudget[identifier].total));
            else if(formattedBudget[identifier].group === 'S') tempSubcontractor += parseFloat((formattedBudget[identifier].total));
            else if(formattedBudget[identifier].group === 'O') tempOther += parseFloat((formattedBudget[identifier].total));
        });

        setMaterialTotal(numberWithCommas(parseFloat((tempMaterial).toFixed(2))));
        setLaborTotal(numberWithCommas(parseFloat((tempLabor).toFixed(2))));
        setEquipmentTotal(numberWithCommas(parseFloat((tempEquipment).toFixed(2))));
        setSubcontractorTotal(numberWithCommas(parseFloat((tempSubcontractor).toFixed(2))));
        setOtherTotal(numberWithCommas(parseFloat((tempOther).toFixed(2))));

        const tempTotal = tempMaterial+tempLabor+tempEquipment+tempSubcontractor+tempOther
        setTotalBudget(numberWithCommas(parseFloat((tempTotal).toFixed(2))));
    };

    // Do this when formatted Budget changes
    useEffect(() => {
        if(formattedBudget) updateTotals();
    },[formattedBudget]);

    // Clear the Budget
    const clearBudget = () => {
        setBudgetImport(null);
        setFormattedBudget(null);
    };

    // Do this when error on budget
    useEffect(() => {
        if(!formattedBudget && formattedBudgetError) clearBudget();
    },[formattedBudgetError]);

*/

//  - - - - - - - - - - - UPDATED BUDGET COMPONENTS - - - - - - - - - - -
const BudgetComponent = ({budgetResponse,budgetResponseErrors}) => {

    // Helper function to format currency
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(amount);
    };

    // Helper function to get account group label
    const getAccountGroupLabel = (group) => {
        const groupLabels = {
            'M': 'Materials',
            'L': 'Labor', 
            'S': 'Subcontractors',
            'E': 'Equipment',
            'O': 'Other'
        };
        return groupLabels[group] || group;
    };

    // Helper function to get account group color
    const getAccountGroupColor = (group) => {
        const groupColors = {
            'M': '#3b82f6', // Blue
            'L': '#10b981', // Green
            'S': '#f59e0b', // Amber
            'E': '#8b5cf6', // Purple
            'O': '#6b7280'  // Gray
        };
        return groupColors[group] || '#6b7280';
    };

    // Group budget items by task for better organization
    const groupedBudget = {};
    Object.entries(budgetResponse.formattedBudget).forEach(([key, item]) => {
        if (!groupedBudget[item.task]) {
            groupedBudget[item.task] = {
                title: item.description,
                items: [],
                total: 0
            };
        }
        groupedBudget[item.task].items.push(item);
        groupedBudget[item.task].total += item.amount;
    });

    return(
        <div className='modern-budget-container'>
            {/* Budget Header */}
            <div className='modern-budget-header'>
                <h3 className='modern-budget-title'>Project Budget Breakdown</h3>
                <div className='modern-budget-total'>
                    <span className='budget-total-label'>Total Project Cost:</span>
                    <span className='budget-total-amount'>{formatCurrency(budgetResponse.totalCost)}</span>
                </div>
            </div>

            {/* Error Display */}
            {budgetResponse.errorList && budgetResponse.errorList.length > 0 && (
                <div className='modern-budget-errors'>
                    <h4>Issues Found:</h4>
                    {budgetResponse.errorList.map((error, index) => (
                        <div key={index} className='budget-error-item'>
                            <span className='error-icon'>⚠️</span>
                            {error}
                        </div>
                    ))}
                </div>
            )}

            {budgetResponseErrors && (
                <div className='modern-budget-validation-error'>
                    <span className='error-icon'>❌</span>
                    {budgetResponseErrors}
                </div>
            )}

            {/* Task Summary Cards */}
            <div className='modern-budget-task-summary'>
                <h4 className='summary-title'>Summary by Task</h4>
                <div className='task-cards-grid'>
                    {Object.entries(budgetResponse.stats).map(([taskCode, taskData]) => (
                        <div key={taskCode} className='task-summary-card'>
                            <div className='task-card-header'>
                                <span className='task-code'>{taskCode}</span>
                                <span className='task-amount'>{formatCurrency(taskData.amount)}</span>
                            </div>
                            <div className='task-title'>{taskData.title}</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Detailed Budget Items */}
            <div className='modern-budget-details'>
                <h4 className='details-title'>Detailed Breakdown</h4>
                
                {Object.entries(groupedBudget).map(([taskCode, taskGroup]) => (
                    <div key={taskCode} className='task-group'>
                        <div className='task-group-header'>
                            <h5 className='task-group-title'>
                                <span className='task-group-code'>{taskCode}</span>
                            </h5>
                            <span className='task-group-total'>{formatCurrency(taskGroup.total)}</span>
                        </div>
                        
                        <div className='budget-items-list'>
                            {taskGroup.items.map((item, index) => (
                                <div key={`${taskCode}-${index}`} className='budget-item'>
                                    <div className='budget-item-main'>
                                        <div className='budget-item-header'>
                                            <span className='cost-code'>{item.costCode}</span>
                                            <div className='account-group-badge' 
                                                 style={{ backgroundColor: getAccountGroupColor(item.group) }}>
                                                {getAccountGroupLabel(item.group)}
                                            </div>
                                        </div>
                                        <div className='budget-item-description'>{item.description}</div>
                                    </div>
                                    
                                    <div className='budget-item-details'>
                                        {item.quantity && (
                                            <div className='item-detail'>
                                                <span className='detail-label'>Qty:</span>
                                                <span className='detail-value'>{item.quantity} {item.uom}</span>
                                            </div>
                                        )}
                                        {item.unitRate && (
                                            <div className='item-detail'>
                                                <span className='detail-label'>Rate:</span>
                                                <span className='detail-value'>{formatCurrency(item.unitRate)}</span>
                                            </div>
                                        )}
                                        <div className='budget-item-amount'>{formatCurrency(item.amount)}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            {/* Account Group Totals */}
            <div className='modern-budget-group-totals'>
                <h4 className='group-totals-title'>Totals by Account Group</h4>
                <div className='group-totals-grid'>
                    {Object.entries(budgetResponse.formattedBudget).reduce((acc, [key, item]) => {
                        if (!acc[item.group]) {
                            acc[item.group] = 0;
                        }
                        acc[item.group] += item.amount;
                        return acc;
                    }, {}) && Object.entries(
                        Object.entries(budgetResponse.formattedBudget).reduce((acc, [key, item]) => {
                            if (!acc[item.group]) {
                                acc[item.group] = 0;
                            }
                            acc[item.group] += item.amount;
                            return acc;
                        }, {})
                    ).map(([group, total]) => (
                        <div key={group} className='group-total-card'>
                            <div className='group-total-header'>
                                <div className='group-total-badge' 
                                     style={{ backgroundColor: getAccountGroupColor(group) }}>
                                    {getAccountGroupLabel(group)}
                                </div>
                            </div>
                            <div className='group-total-amount'>{formatCurrency(total)}</div>
                            <div className='group-total-percentage'>
                                {((total / budgetResponse.totalCost) * 100).toFixed(1)}%
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

//  - - - - - - - - - - - FIELD COMPONENTS - - - - - - - - - - -

const DateInputField = ({title, value, setTo, locked, width=300, searchCustomer}) => {
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            if(searchCustomer) searchCustomer();
        }
    };

    return(
        <div className='Project-Booking-Input-Field'>
            <div className='Project-Booking-Input-Field-Label'>
                {title}:
            </div>
            {   !locked &&
                <input className='Project-Booking-Input-Field-Input' type='date' style={{width:`${width}px`}} value={value} onChange={e => setTo(e.target.value)} onKeyDown={e => handleKeyDown(e)}/>
            }
            {   locked &&
                <input className='Project-Booking-Input-Field-Input' disabled style={{width:`${width}px`}} value={value} onChange={e => setTo(e.target.value)}/>
            }
        </div>
    )
};

const SelectInputField = ({title, value, setTo, locked=false, options, complete=null}) => {
    return(
        <div className='Project-Booking-Input-Field'>          
            <div className='Project-Booking-Input-Field-Label'>
                {title}:
                {complete === false && <span className="required-indicator">*</span>}
                {complete === true && <span className="complete-indicator">✓</span>}
            </div>
            <div className={`Project-Booking-Input-Field-Container ${complete === false ? 'incomplete' : ''} ${complete === true ? 'complete' : ''}`}>
                {locked ? (
                    <select 
                        onChange={e => setTo(e.target.value)} 
                        value={value} 
                        disabled
                        className="modern-select-input"
                    >
                        <option value="" disabled hidden>Select an option</option>
                        {options.map((element, key) => (
                            <option key={key} value={element.value}>{element.text}</option>
                        ))}
                    </select>
                ) : (
                    <select 
                        onChange={e => setTo(e.target.value)} 
                        value={value}
                        className="modern-select-input"
                    >
                        <option value="" disabled hidden>Select an option</option>
                        {options.map((element, key) => (
                            <option key={key} value={element.value}>{element.text}</option>
                        ))}
                    </select>
                )}
            </div>
        </div>
    )
};

const DisplayValueField = ({title, value, width=250, suffix='%'}) => {
    const formatValue = (val) => {
        if (val === null || val === undefined || val === '') return '--';
        if (isNaN(val)) return '--';
        
        const numValue = parseFloat(val);
        if (suffix === '%') {
            return `${numValue.toFixed(2)}${suffix}`;
        }
        return numValue.toFixed(2);
    };

    return(
        <div className='Project-Booking-Input-Field'>
            <div className='Project-Booking-Input-Field-Label'>
                {title}:
            </div>
            <div 
                className='Project-Booking-Display-Value-Field' 
                style={{width: `${width}px`}}
            >
                {formatValue(value)}
            </div>
        </div>
    )
};

//  - - - - - - - - - - - PROJECT REQUIRED - - - - - - - - - - -
const ProjectRequiredForm = ({projectRequired,setProjectRequired}) => {
    setProjectRequired(true);
    
    return(
        <div>
            
        </div>
    )
};

//  - - - - - - - - - - - BRANCH & MANAGER - - - - - - - - - - - 
const BranchManagementForm = ({projectManager,setProjectManager,projectManagerComplete, projectManagerList,branch,setBranch, branchComplete}) => {
    return(
        <>
            <SelectInputField title={'Branch'} value={branch} setTo={setBranch} options={branchOptions} complete={branchComplete}/>
            {   projectManagerList.length < 1 && branch &&
                <LoadingSpinner size={60}/>
            }
            {   projectManagerList.length > 0 && projectManagerList[0].value &&
                <SelectInputField title={'Project Manager'} value={projectManager} setTo={setProjectManager} options={projectManagerList} complete={projectManagerComplete}/>
            }
            {   projectManagerList.length > 0 && !projectManagerList[0].value &&
            <>
                <div>
                    No Project Managers Listed at This Branch.
                </div>
                <div>
                    Please select a different branch or reach out to IT to add PMs to the system for this branch.
                </div>
            </>
            }

        </>
    )
};

const ProjectTypeForm = ({projectType, setProjectType, projectTypeComplete}) => {
    return(
        <SelectInputField title={'Job Type'} value={projectType} setTo={setProjectType} options={requestTypeOptions} complete={projectTypeComplete}/>
    )
};

//  - - - - - - - - - - - PROJECT - - - - - - - - - - - 
const ProjectDetailsForm = ({projectName,setProjectName,projectNameComplete, projectStreet,setProjectStreet, projectStreetComplete, projectCity,setProjectCity,projectCityComplete,
    projectState,setProjectState, projectStateComplete,projectZip,setProjectZip,projectZipComplete,
    taxStatus,setTaxStatus,taxStatusComplete,ownerDirectPurchase,setOwnerDirectPurchase,ownerDirectPurchaseComplete,prevailingWage,setPrevailingWage,prevailingWageComplete,
    bondRequired,setBondRequired,bondRequiredComplete,businessLicenseRequired,setBusinessLicenseRequired,businessLicenseRequiredComplete,permitsRequired,setPermitsRequired,permitsRequiredComplete,ccipInsurance,setCcipInsurance,ccipInsuranceComplete,
    warrantyPeriod,setWarrantyPeriod,warrantyPeriodComplete,modification,setModification,modificationComplete, intercompanyProject, setIntercompanyProject, intercompanyProjectComplete,
    projectCountry, setProjectCountry, projectCountryComplete, projectCountryList}) => {

    return(
        <div className='Project-Booking-Input-Form'>
            <StandardInputField title={'Project Name'} value={projectName} setTo={setProjectName} complete={projectNameComplete}/>

            <AddressInputField title={'Project Address'} street={projectStreet} setStreet={setProjectStreet} city={projectCity} setCity={setProjectCity} state={projectState} setState={setProjectState} zip={projectZip} setZip={setProjectZip} 
            streetComplete={projectStreetComplete} cityComplete={projectCityComplete} stateComplete={projectStateComplete} zipComplete={projectZipComplete} country={projectCountry} setCountry={setProjectCountry} countryList={projectCountryList} countryComplete={projectCountryComplete}/>

            <div className='Project-Booking-field-title'>
                Details
            </div>
            <SelectInputField title={'Tax Status'} value={taxStatus} setTo={setTaxStatus} options={taxabilityOptions} complete={taxStatusComplete}/>
            {   projectState === 'AZ' &&
                <SelectInputField title={'Modification'} value={modification} setTo={setModification} options={[{text:'Yes', value:true},{text:'No',value:false}]} complete={modificationComplete}/>
            }
            <SelectInputField title={'Involves Intercompany Participation'} value={intercompanyProject} setTo={setIntercompanyProject} options={[{text:'Yes', value:true},{text:'No',value:false}]} complete={intercompanyProjectComplete}/>
            <SelectInputField title={'Owner Direct Purchase (Confirm with Corporate Accounting before selecting Yes)'} value={ownerDirectPurchase} setTo={setOwnerDirectPurchase} options={[{text:'Yes', value:true},{text:'No',value:false}]} complete={ownerDirectPurchaseComplete}/>
            <SelectInputField title={'Certified Payroll / Prevailing Wage'} value={prevailingWage} setTo={setPrevailingWage} options={[{text:'Yes', value:true},{text:'No',value:false}]} complete={prevailingWageComplete}/>
            <SelectInputField title={'Bond Required'} value={bondRequired} setTo={setBondRequired} options={[{text:'Yes', value:true},{text:'No',value:false}]} complete={bondRequiredComplete}/>
            <SelectInputField title={'Business License Required'} value={businessLicenseRequired} setTo={setBusinessLicenseRequired} options={[{text:'Yes', value:true},{text:'No',value:false}]} complete={businessLicenseRequiredComplete}/>
            <SelectInputField title={'Permits Required'} value={permitsRequired} setTo={setPermitsRequired} options={[{text:'Yes', value:true},{text:'No',value:false}]} complete={permitsRequiredComplete}/>
            <SelectInputField title={'CCIP or OCIP Insurance'} value={ccipInsurance} setTo={setCcipInsurance} options={[{text:'Yes', value:true},{text:'No',value:false}]} complete={ccipInsuranceComplete}/>
            <StandardInputField title={'Warranty Period (Months)'} value={warrantyPeriod} setTo={setWarrantyPeriod} complete={warrantyPeriodComplete}/>
        </div>
    )
};

const ProjectContractForm = ({defaultRetainage,setDefaultRetainage,defaultRetainageComplete,totalContractAmount,setTotalContractAmount,totalContractAmountComplete,
    totalCostAmount,setTotalCostAmount,totalCostAmountComplete,margin,setMargin}) => {
    return(
        <div className='Project-Booking-Input-Form'>
            <DollarInputField title={'Total Contract Amount'} width={400} value={totalContractAmount} setTo={setTotalContractAmount} complete={totalContractAmountComplete}/>
            <DollarInputField title={'Total Estimated Cost'} width={400}  value={totalCostAmount} setTo={setTotalCostAmount}complete={totalCostAmountComplete}/>
            <PercentageInputField title={'Margin'} value={margin} setTo={setMargin} locked={true}/>
            <PercentageInputField title={'Default Retainage'} value={defaultRetainage} setTo={setDefaultRetainage}complete={defaultRetainageComplete}/>
        </div>
    )
};

//  - - - - - - - - - - - SERVICE - - - - - - - - - - - 
const ServiceDetailsForm = ({projectName,setProjectName,projectNameComplete,projectStreet,setProjectStreet,projectStreetComplete,projectCity,setProjectCity,projectCityComplete,
    projectState,setProjectState,projectStateComplete,projectZip,setProjectZip,projectZipComplete,
    taxStatus,setTaxStatus,taxStatusComplete,prevailingWage,setPrevailingWage,prevailingWageComplete,
    bondRequired,setBondRequired,bondRequiredComplete,businessLicenseRequired,setBusinessLicenseRequired,businessLicenseRequiredComplete,permitsRequired,setPermitsRequired,permitsRequiredComplete,
    projectCountry, setProjectCountry, projectCountryComplete, projectCountryList}) => {

    return(
        <div className='Project-Booking-Input-Form'>
            <StandardInputField title={'Project Name'} value={projectName} setTo={setProjectName} complete={projectNameComplete}/>

            <AddressInputField title={'Project Address'} street={projectStreet} setStreet={setProjectStreet} city={projectCity} setCity={setProjectCity} state={projectState} setState={setProjectState} zip={projectZip} setZip={setProjectZip} 
            streetComplete={projectStreetComplete} cityComplete={projectCityComplete} stateComplete={projectStateComplete} zipComplete={projectZipComplete} country={projectCountry} setCountry={setProjectCountry} countryList={projectCountryList} countryComplete={projectCountryComplete}/>

            <div className='Project-Booking-field-title'>
                Details
            </div>
            <SelectInputField title={'Tax Status'} value={taxStatus} setTo={setTaxStatus} options={taxabilityOptions} complete={taxStatusComplete}/>
            <SelectInputField title={'Certified Payroll / Prevailing Wage'} value={prevailingWage} setTo={setPrevailingWage} options={[{text:'Yes', value:true},{text:'No',value:false}]} complete={prevailingWageComplete}/>
            <SelectInputField title={'Bond Required'} value={bondRequired} setTo={setBondRequired} options={[{text:'Yes', value:true},{text:'No',value:false}]} complete={bondRequiredComplete}/>
            <SelectInputField title={'Business License Required'} value={businessLicenseRequired} setTo={setBusinessLicenseRequired} options={[{text:'Yes', value:true},{text:'No',value:false}]} complete={businessLicenseRequiredComplete}/>
            <SelectInputField title={'Permits Required'} value={permitsRequired} setTo={setPermitsRequired} options={[{text:'Yes', value:true},{text:'No',value:false}]} complete={permitsRequiredComplete}/>
        </div>
    )
};

const ServiceContractForm = ({serviceContractList,setServiceContractList,handleContractChange}) => {
    let activated = false;
    const [updating, setUpdating ] = useState(false);


    const handleChange = (object) => {
        let tempList = serviceContractList;
        tempList[object.contractYear-1] = object;

        handleContractChange(tempList);
    };

    const removeYear = () => {
       let tempList = serviceContractList;
        setUpdating(true);
        setTimeout(() => {
            setUpdating(false);
        },10);

        tempList.pop();
        
        setServiceContractList(tempList);
    };

    const createNewBlankYear = () => {
        let tempList = serviceContractList;
        setUpdating(true);
        setTimeout(() => {
            setUpdating(false);
        },10);

        if(tempList.length < 1){
            const tempYear = {
                contractYear: 1,
                startDate: '',
                endDate: '',
                billingRule: '',
                contractAmount: 0,
                costAmount: 0,
                presoldHours: 0,
                materialAllowance: 0,
                travelTime: 0,
            };
    
            tempList.push(tempYear);    
        }
        else{
            // Add one day to the previous end date to avoid overlap
            const previousEndDate = new Date(tempList[tempList.length-1].endDate);
            previousEndDate.setDate(previousEndDate.getDate() + 1);
            const newStartDate = previousEndDate.toISOString().split('T')[0];

            // Calculate end date as exactly one year from start date
            const startDateObj = new Date(newStartDate);
            const endDateObj = new Date(startDateObj);
            endDateObj.setFullYear(startDateObj.getFullYear() + 1);
            const newEndDate = endDateObj.toISOString().split('T')[0];

            const tempYear = {
                contractYear: tempList.length+1,
                startDate: newStartDate,
                endDate: newEndDate,
                billingRule: tempList[tempList.length-1].billingRule,
                contractAmount: tempList[tempList.length-1].contractAmount,
                costAmount: tempList[tempList.length-1].costAmount,
                presoldHours: tempList[tempList.length-1].presoldHours,
                materialAllowance: tempList[tempList.length-1].materialAllowance,
                travelTime: tempList[tempList.length-1].travelTime,
            };
    
            tempList.push(tempYear);  
        }

        setServiceContractList(tempList);
    };

    useEffect(() => {
        if(!activated && serviceContractList.length < 1){
            activated = true;
            createNewBlankYear();
        };
    },[]);

    const ServiceContractComponent = ({contractYear,startDate,endDate,billingRule,contractAmount,costAmount,presoldHours,materialAllowance,travelTime,handleChange}) => {
        const [start, setStart] = useState(`${startDate ? organizeInputDate(startDate) : ''}`);
        const [end, setEnd] = useState(`${endDate ? organizeInputDate(endDate) : ''}`);
        const [billing, setBilling] = useState(billingRule);
        const [value, setValue] = useState(contractAmount);
        const [cost, setCost] = useState(costAmount);
        const [hours, setHours] = useState(presoldHours);
        const [materials,setMaterials] = useState(materialAllowance);
        const [travel,setTravel] = useState(travelTime);

        useEffect(() => {        
            if(start && !end){
                let tempEndYear = parseInt(start.substring(0, 4));
                tempEndYear += 1;
                setEnd(tempEndYear + start.slice(4));
            };

            const tempObject = {
                contractYear:contractYear,
                startDate:start,
                endDate:end,
                billingRule:billing,
                contractAmount:value,
                costAmount:cost,
                presoldHours:hours,
                materialAllowance:materials,
                travelTime:travel,
            };

            handleChange(tempObject);
        },[start,end,billing,value,cost,hours,materials,travel]);
        
        return(
            <div className='Project-Booking-Service-Contract-Component'>
                <StandardInputField title={"Year"} value={contractYear} locked={true} width={50}/>
                <DateInputField title={"Contract Start Date"} value={start} setTo={setStart} width={150}/>
                <DateInputField title={"Contract End Date"} value={end} setTo={setEnd} width={150}/>
                <DollarInputField title={"Contract Value"} value={value} setTo={setValue} width={150}/>
                <DollarInputField title={"Budgeted Costs"} value={cost} setTo={setCost} width={150}/>
                <DisplayValueField title={"Margin"} value={((value - cost)/value)*100} width={150}/>
                <SelectInputField title={"Billing Rule"} value={billing} setTo={setBilling} options={billingOptions}/>
                <StandardInputField title={"Presold Hours"} value={hours} setTo={setHours}  width={150}/>
                <DollarInputField title={"Presold Material Allowance"} value={materials} setTo={setMaterials} width={150}/>
                <StandardInputField title={"Billable Travel Time"} value={travel} setTo={setTravel}  width={150}/>
            </div>
        )
    };

    return(
        <div className='Project-Booking-Service-Contract-Form'>
            { 
                serviceContractList.map((element,key) => (
                    <ServiceContractComponent {...element} handleChange={handleChange} removeYear={removeYear} key={key}/>
                ))
            }
            <button className='Project-Booking-Service-Contract-Add' onClick={() => createNewBlankYear()}>Add A Year</button>
            {   serviceContractList.length > 1 &&
            <button className='Project-Booking-Service-Contract-Remove' onClick={() => removeYear()}>Remove Year</button>
            }
        </div>
    )
};

const LinkForm = ({salesLink,setSalesLink,salesLinkComplete}) => {
    return(
        <div className='Project-Booking-Section'>
        <div className='Project-Booking-Section-Title'>Links</div>
            <div className='Project-Booking-Input-Form'>
                <StandardInputField title={'Sales Folder Link'} value={salesLink} setTo={setSalesLink} width={500} complete={salesLinkComplete}/>
            </div>
            {   !salesLinkComplete &&
                <>
                    <div className='Project-Booking-Input-Field-Error'>
                        Sales Folder Link is required. Copy and paste the online Box folder where the estimating files for this project have been stored. Navigate to https://cornerstonedetentionproducts.account.box.com/login
                    </div>

                </>
            }
        </div>

    );
};

const FilesForm = ({contractFile,setContractFile,contractFileComplete,prevailingWage,prevailingWageFile,setPrevailingWageFile,prevailingWageFileComplete,bondRequired,bondFile,setBondFile,bondFileComplete,
    taxStatus,taxExemptFile,setTaxExemptFile,taxExemptFileComplete,ccipInsurance,certificateFile,setCertificateFile,certificateFileComplete,
    contractFileId,prevailingWageFileId,bondFileId,taxExemptFileId,certificateFileId,financialTabFile,financialTabFileId,setFinancialTabFile,financialTabFileComplete, intercompanyProject}) => {

    // Helper function to get validation class
    const getValidationClass = (complete) => {
        if (complete === null || complete === undefined) return '';
        if (complete === false) return 'incomplete';
        if (complete === true) return 'complete';
        return '';
    };

    // Helper function to get validation indicator
    const getValidationIndicator = (complete) => {
        if (complete === null || complete === undefined) return <span className="optional-indicator">(Optional)</span>;
        if (complete === false) return <span className="required-indicator">*</span>;
        if (complete === true) return <span className="complete-indicator">✓</span>;
        return null;
    };

    return(
        <div className='files-form-container'>
            {/* Contract File */}
            <div className={`Project-Booking-File-Insert ${getValidationClass(contractFileComplete)}`}>
                <div className='Project-Booking-File-Insert-Label'>
                    Upload Award Documentation such as Contracts (signed copies if available), Letters of Intent, Notices to Proceed, Purchase Orders, etc.
                    {getValidationIndicator(contractFileComplete)}
                </div>
                <div className='Project-Booking-File-Insert-Description'>
                    Please upload the final signed contract document in PDF format.
                </div>
                <input 
                    type='file' 
                    accept=".pdf" 
                    onChange={(e) => setContractFile(e.target.files)}
                    className={`Project-Booking-File-Insert-File ${getValidationClass(contractFileComplete)}`}
                />
            </div>
            {contractFileId && !contractFile && (
                <div className='Project-Booking-File-Update'>
                    A contract file has already been uploaded. Choosing a new file will overwrite the stored version.
                </div>
            )}

            {/* Certified Payroll / Prevailing Wage */}
            {prevailingWage === 'true' && (
                <>
                    <div className={`Project-Booking-File-Insert ${getValidationClass(prevailingWageFileComplete)}`}>
                        <div className='Project-Booking-File-Insert-Label'>
                            Certified Payroll / Prevailing Wage Rate Sheet
                            {getValidationIndicator(prevailingWageFileComplete)}
                        </div>
                        <div className='Project-Booking-File-Insert-Description'>
                            Upload only the pages of the Certified Payroll / Prevailing Wage Rate Sheet that apply with the rates clearly marked.
                        </div>
                        <input 
                            type='file' 
                            accept=".pdf" 
                            onChange={(e) => setPrevailingWageFile(e.target.files)}
                            className={`Project-Booking-File-Insert-File ${getValidationClass(prevailingWageFileComplete)}`}
                        />
                    </div>
                    {prevailingWageFileId && !prevailingWageFile && (
                        <div className='Project-Booking-File-Update'>
                            A Certified Payroll / Prevailing Wage file has already been uploaded. Choosing a new file will overwrite the stored version.
                        </div>
                    )}
                </>
            )}

            {/* Bond Required */}
            {bondRequired === 'true' && (
                <>
                    <div className={`Project-Booking-File-Insert ${getValidationClass(bondFileComplete)}`}>
                        <div className='Project-Booking-File-Insert-Label'>
                            Bonding Requirements
                            {getValidationIndicator(bondFileComplete)}
                        </div>
                        <div className='Project-Booking-File-Insert-Description'>
                            Upload the bonding requirements documentation.
                        </div>
                        <input 
                            type='file' 
                            accept=".pdf" 
                            onChange={(e) => setBondFile(e.target.files)}
                            className={`Project-Booking-File-Insert-File ${getValidationClass(bondFileComplete)}`}
                        />
                    </div>
                    {bondFileId && !bondFile && (
                        <div className='Project-Booking-File-Update'>
                            A Bonding file has already been uploaded. Choosing a new file will overwrite the stored version.
                        </div>
                    )}
                </>
            )}

            {/* Tax Exemption */}
            {taxStatus === 'Exempt' && (
                <>
                    <div className={`Project-Booking-File-Insert ${getValidationClass(taxExemptFileComplete)}`}>
                        <div className='Project-Booking-File-Insert-Label'>
                            Tax Exemption Certificate
                            {getValidationIndicator(taxExemptFileComplete)}
                        </div>
                        <div className='Project-Booking-File-Insert-Description'>
                            Upload the tax exemption certificate documentation.
                        </div>
                        <input 
                            type='file' 
                            accept=".pdf" 
                            onChange={(e) => setTaxExemptFile(e.target.files)}
                            className={`Project-Booking-File-Insert-File ${getValidationClass(taxExemptFileComplete)}`}
                        />
                    </div>
                    {taxExemptFileId && !taxExemptFile && (
                        <div className='Project-Booking-File-Update'>
                            A Tax Exemption file has already been uploaded. Choosing a new file will overwrite the stored version.
                        </div>
                    )}
                </>
            )}

            {/* Insurance Program */}
            {ccipInsurance  === 'true' && (
                <>
                    <div className={`Project-Booking-File-Insert ${getValidationClass(certificateFileComplete)}`}>
                        <div className='Project-Booking-File-Insert-Label'>
                            {ccipInsurance} Insurance Details
                            {getValidationIndicator(certificateFileComplete)}
                        </div>
                        <div className='Project-Booking-File-Insert-Description'>
                            Upload CCIP or OCIP insurance program documentation.
                        </div>
                        <input 
                            type='file' 
                            accept=".pdf" 
                            onChange={(e) => setCertificateFile(e.target.files)}
                            className={`Project-Booking-File-Insert-File ${getValidationClass(certificateFileComplete)}`}
                        />
                    </div>
                    {certificateFileId && !certificateFile && (
                        <div className='Project-Booking-File-Update'>
                            An Insurance Program file has already been uploaded. Choosing a new file will overwrite the stored version.
                        </div>
                    )}
                </>
            )}

            {/* Intercompany Breakout */}
            {intercompanyProject === 'true' && (
                <>
                    <div className={`Project-Booking-File-Insert ${getValidationClass(financialTabFileComplete)}`}>
                        <div className='Project-Booking-File-Insert-Label'>
                            Intercompany Breakout
                            {getValidationIndicator(financialTabFileComplete)}
                        </div>
                        <div className='Project-Booking-File-Insert-Description'>
                            Upload the Intercompany Breakout documentation as an excel file.
                        </div>
                        <input 
                            type='file' 
                            accept=".xlsx" 
                            onChange={(e) => setFinancialTabFile(e.target.files)}
                            className={`Project-Booking-File-Insert-File ${getValidationClass(financialTabFileComplete)}`}
                        />
                    </div>
                    {financialTabFileId && !financialTabFile && (
                        <div className='Project-Booking-File-Update'>
                            An Intercompany Breakout file has already been uploaded. Choosing a new file will overwrite the stored version.
                        </div>
                    )}
                </>
            )}
        </div>
    )
};

const BudgetSkipForm = ({budgetSkipReason,setBudgetSkipReason}) => {
    return(
        <div className='Project-Booking-Skip-Budget'>
            <textarea className='Project-Booking-Skip-Budget-Input' value={budgetSkipReason} onChange={e => setBudgetSkipReason(e.target.value)} />
        </div>
    )
};

const RejectionWindow = ({rejectionList, getForm, rejectionSelected, cancelRejection}) => {
    const [expanded, setExpanded] = useState(false);

    const selectRejection = (id) => {
        setExpanded(false);
        getForm(id);
    };

    const toggleExpanded = () => {
        setExpanded(!expanded);
    };

    const RejectionCard = ({rejection}) => {
        return(
            <div className='Project-Booking-Rejection-Card' onClick={() => selectRejection(rejection.recordId)}>
                <div className='Project-Booking-Rejection-Card-Header'>
                    <MdError className='Project-Booking-Rejection-Card-Icon' />
                    <div className='Project-Booking-Rejection-Card-Status'>
                        REJECTED
                    </div>
                </div>
                
                <div className='Project-Booking-Rejection-Card-Content'>
                    <div className='Project-Booking-Rejection-Card-Field'>
                        <span className='Project-Booking-Rejection-Card-Label'>Project:</span>
                        <span className='Project-Booking-Rejection-Card-Value'>{rejection.projectName}</span>
                    </div>
                    
                    <div className='Project-Booking-Rejection-Card-Field'>
                        <span className='Project-Booking-Rejection-Card-Label'>Date Rejected:</span>
                        <span className='Project-Booking-Rejection-Card-Value'>{organizeDate(rejection.date)}</span>
                    </div>
                </div>
                
                <div className='Project-Booking-Rejection-Card-Action'>
                    Click to view and edit
                </div>
            </div>
        )
    };

    const RejectionAlert = () => {
        return(
            <div className='Project-Booking-Rejection-Alert'>
                <div className='Project-Booking-Rejection-Alert-Content'>
                    <div className='Project-Booking-Rejection-Alert-Icon-Container'>
                        <MdError className='Project-Booking-Rejection-Alert-Icon' />
                    </div>
                    <div className='Project-Booking-Rejection-Alert-Info'>
                        <div className='Project-Booking-Rejection-Alert-Title'>
                            {rejectionList.length} Rejected Request{rejectionList.length !== 1 ? 's' : ''} Found
                        </div>
                        <div className='Project-Booking-Rejection-Alert-Subtitle'>
                            Please review and address the rejected submissions below
                        </div>
                    </div>
                    <button 
                        className='Project-Booking-Rejection-Alert-Toggle'
                        onClick={toggleExpanded}
                    >
                        {expanded ? 'Hide' : 'View'} Rejections
                    </button>
                </div>
            </div>
        )
    };

    const RejectionDetails = () => {
        return(
            <div className='Project-Booking-Rejection-Details'>
                <div className='Project-Booking-Rejection-Details-Header'>
                    <div className='Project-Booking-Rejection-Details-Icon-Container'>
                        <MdError className='Project-Booking-Rejection-Details-Icon' />
                    </div>
                    <div className='Project-Booking-Rejection-Details-Info'>
                        <div className='Project-Booking-Rejection-Details-Title'>
                            Project Request Rejected
                        </div>
                        <div className='Project-Booking-Rejection-Details-Project'>
                            {rejectionSelected.projectName}
                        </div>
                    </div>
                    <button 
                        className='Project-Booking-Rejection-Details-Close'
                        onClick={cancelRejection}
                    >
                        ✕ Close
                    </button>
                </div>
                
                <div className='Project-Booking-Rejection-Details-Content'>
                    <div className='Project-Booking-Rejection-Details-Section'>
                        <div className='Project-Booking-Rejection-Details-Section-Title'>
                            Rejection Reason:
                        </div>
                        <div className='Project-Booking-Rejection-Details-Reason'>
                            {rejectionSelected.rejectionText}
                        </div>
                    </div>
                    
                    <div className='Project-Booking-Rejection-Details-Meta'>
                        <div className='Project-Booking-Rejection-Details-Meta-Item'>
                            <span className='Project-Booking-Rejection-Details-Meta-Label'>Date Rejected:</span>
                            <span className='Project-Booking-Rejection-Details-Meta-Value'>{organizeDate(rejectionSelected.date)}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    return(
        <div className='Project-Booking-Rejection-Window'>
            {!rejectionSelected && (
                <>
                    <RejectionAlert />
                    
                    {expanded && (
                        <div className='Project-Booking-Rejection-List'>
                            <div className='Project-Booking-Rejection-List-Header'>
                                <h3>Rejected Submissions</h3>
                                <div className='Project-Booking-Rejection-List-Count'>
                                    {rejectionList.length} item{rejectionList.length !== 1 ? 's' : ''}
                                </div>
                            </div>
                            
                            <div className='Project-Booking-Rejection-Cards'>
                                {rejectionList.map((rejection, key) => (
                                    <RejectionCard key={key} rejection={rejection} />
                                ))}
                            </div>
                        </div>
                    )}
                </>
            )}
            
            {rejectionSelected && (
                <RejectionDetails />
            )}
        </div>
    )
};

const ServiceBudgetComponent = ({generateServiceContractTemplate, serviceCostBudgetTemplate, setServiceCostFile, budgetResponse, budgetError, clearBudget, refreshBudgetTotals}) => {
    return (
        <>
            {   !budgetResponse &&
                <>
                    <div className='Project-Booking-Service-Budget-Instruction'>
                        A budget will be created using the contract details entered above.
                    </div>
                    <div className='Project-Booking-Service-Budget-Instruction'>
                        If these change, redownload the template to get an updated version.
                    </div>
                    <div className='Project-Booking-Service-Budget-Instruction'>
                        Values left with a total of $0 will be ignored when the import is completed.
                    </div>
                    <div className='Project-Booking-Service-Budget-Template'>
                        <button onClick={() => generateServiceContractTemplate()}>Download Cost Budget Template</button>
                    </div>

                    <div className='Project-Booking-File-Insert-Description'>
                        Upload Completed Service Cost Budget
                    </div>
                    <input type='file' accept=".xls,.xlsx" onChange={(e) => setServiceCostFile(e.target.files)}className='Project-Booking-Budget-Import-Upload'/>
                </>
                
            }

            {   budgetResponse &&
                <div className='Project-Booking-Budget-Import-Response'>
                    <div className='Project-Booking-Service-Budget-Template-Buttons'>
                        <button onClick={() => clearBudget()}>Reset Budget</button>
                        <button onClick={() => refreshBudgetTotals()}>Refresh Budget Totals</button>
                    </div>
                    <BudgetComponent budgetResponse={budgetResponse} budgetResponseErrors={budgetError}/>
                </div>
                
            }

            {   budgetError &&
                <div className='Project-Booking-Error-Line'>{budgetError}</div>
            }


        </>
    );
};

const ProjectBooking = () => {
    const contextObject = useContext(Context);

    const [projectRequired, setProjectRequired] = useState(false);

    // CUSTOMER - - - - - - - 
    const [customerSelected, setCustomerSelected] = useState(null);
    const [locationSelected, setLocationSelected] = useState(null);
    const [customerPoNumber, setCustomerPoNumber] = useState('');
    const [entitySelection, setEntitySelection] = useState(true);
    const [enitityShown, setEntityShown] = useState(false);
    const [entityName, setEntityName] = useState('');

    useEffect(() => {
        if(entitySelection === 'true' || entitySelection === true){
            setEntityShown(false);
        }
        else{
            setEntityShown(true);
        }
        if(entitySelection) setEntityName('');
    },[entitySelection]);


    // BRANCH & MANAGER - - - - - - - 
    const [branch,setBranch] = useState('');
    const [branchComplete, setBranchComplete] = useState(false);
    const [projectManager,setProjectManager] = useState('');
    const [projectManagerComplete, setProjectManagerComplete] = useState(false);
    const [projectManagerList,setProjectManagerList] = useState([]);
    const [projectManagerError,setProjectManagerError] = useState('');
    const [branchAndManagerComplete, setBranchAndManagerComplete] = useState(false);

    useEffect(() => {

        if(branch) setBranchComplete(true);
        else setBranchComplete(false);

        if(projectManager) setProjectManagerComplete(true);
        else setProjectManagerComplete(false);

        if(branch && projectManager) setBranchAndManagerComplete(true);
        else setBranchAndManagerComplete(false);
    },[branch,projectManager]);

    useEffect(() => {
        if(branch) getFilteredProjectManagers(contextObject.apiToken,branch,setProjectManagerList,setProjectManagerError);
    },[branch]);

    const branchManagementProps = {
        projectManager:projectManager,
        setProjectManager:setProjectManager,
        projectManagerComplete:projectManagerComplete,
        projectManagerList:projectManagerList,
        branch:branch,
        setBranch:setBranch,
        branchComplete:branchComplete,
    };

    // PROJECT SELECTION - - - - - - - 
    const [projectType, setProjectType] = useState('');
    const [projectTypeComplete, setProjectTypeComplete] = useState(false);

    useEffect(() => {
        if(projectType) setProjectTypeComplete(true);
        else setProjectTypeComplete(false);

        if(projectType && projectType === 'Service'){
            setBudgetAvailable('Service');
        };
    },[projectType]);

    // PROJECT DETAILS  - - - - - - - 
    const [projectName, setProjectName] = useState('');
    const [projectNameComplete, setProjectNameComplete] = useState(false);
    const [projectNameError, setProjectNameError] = useState('');
    const [projectStreet,setProjectStreet] = useState('');
    const [projectStreetComplete, setProjectStreetComplete] = useState(false);
    const [projectStreet2,setProjectStreet2] = useState('');
    const [projectCity,setProjectCity] = useState('');
    const [projectCityComplete, setProjectCityComplete] = useState(false);
    const [projectState,setProjectState] = useState('');
    const [projectStateComplete, setProjectStateComplete] = useState(false);
    const [projectZip,setProjectZip] = useState('');
    const [projectZipComplete, setProjectZipComplete] = useState(false);
    const [projectAddressError, setProjectAddressError] = useState('');
    const [projectCountry, setProjectCountry] = useState('US');
    const [projectCountryComplete, setProjectCountryComplete] = useState(true);
    const [projectCountryList, setProjectCountryList] = useState(['US', 'CA', 'MX']);
    const [taxStatus, setTaxStatus] = useState('');
    const [taxStatusComplete, setTaxStatusComplete] = useState(false);
    const [ownerDirectPurchase, setOwnerDirectPurchase] = useState('');
    const [ownerDirectPurchaseComplete, setOwnerDirectPurchaseComplete] = useState(false);
    const [intercompanyProject, setIntercompanyProject] = useState('');
    const [intercompanyProjectComplete, setIntercompanyProjectComplete] = useState(false);
    const [prevailingWage, setPrevailingWage] = useState('');
    const [prevailingWageComplete, setPrevailingWageComplete] = useState(false);
    const [bondRequired, setBondRequired] = useState('');
    const [bondRequiredComplete, setBondRequiredComplete] = useState(false);
    const [businessLicenseRequired, setBusinessLicenseRequired] = useState('');
    const [businessLicenseRequiredComplete, setBusinessLicenseRequiredComplete] = useState(false);
    const [permitsRequired, setPermitsRequired] = useState('');
    const [permitsRequiredComplete, setPermitsRequiredComplete] = useState(false);
    const [modification, setModification] = useState('');
    const [modificationComplete, setModificationComplete] = useState(false);
    const [ccipInsurance, setCcipInsurance] = useState('');
    const [ccipInsuranceComplete, setCcipInsuranceComplete] = useState(false);
    const [costAccountGroup, setCostAccountGroup] = useState('');
    const [billingType, setBillingType] = useState('Progressive');
    const [warrantyPeriod, setWarrantyPeriod] = useState();
    const [warrantyPeriodComplete, setWarrantyPeriodComplete] = useState(true);
    const [detailsComplete, setDetailsComplete] = useState(false);

    const projectDetailProps = {
        projectName: projectName,
        setProjectName:setProjectName,
        projectNameComplete:projectNameComplete,
        projectStreet:projectStreet,
        setProjectStreet:setProjectStreet,
        projectStreetComplete:projectStreetComplete,
        projectCity:projectCity,
        setProjectCity:setProjectCity,
        projectCityComplete:projectCityComplete,
        projectState:projectState,
        setProjectState:setProjectState,
        projectStateComplete:projectStateComplete,
        projectZip:projectZip,
        setProjectZip:setProjectZip,
        projectZipComplete:projectZipComplete,
        projectCountry:projectCountry,
        setProjectCountry:setProjectCountry,
        projectCountryComplete:projectCountryComplete,
        projectCountryList:projectCountryList,
        warrantyPeriod:warrantyPeriod,
        setWarrantyPeriod:setWarrantyPeriod,
        warrantyPeriodComplete:warrantyPeriodComplete,
        intercompanyProject: intercompanyProject,
        setIntercompanyProject:setIntercompanyProject,
        intercompanyProjectComplete:intercompanyProjectComplete,
        taxStatus:taxStatus,
        setTaxStatus:setTaxStatus,
        taxStatusComplete:taxStatusComplete,
        ownerDirectPurchase:ownerDirectPurchase,
        setOwnerDirectPurchase:setOwnerDirectPurchase,
        ownerDirectPurchaseComplete:ownerDirectPurchaseComplete,
        prevailingWage:prevailingWage,
        setPrevailingWage:setPrevailingWage,
        prevailingWageComplete:prevailingWageComplete,
        bondRequired:bondRequired,
        setBondRequired:setBondRequired,
        bondRequiredComplete:bondRequiredComplete,
        businessLicenseRequired:businessLicenseRequired,
        setBusinessLicenseRequired:setBusinessLicenseRequired,
        businessLicenseRequiredComplete:businessLicenseRequiredComplete,
        permitsRequired:permitsRequired,
        setPermitsRequired:setPermitsRequired,
        permitsRequiredComplete:permitsRequiredComplete,
        modification:modification,
        setModification:setModification,
        modificationComplete:modificationComplete,
        ccipInsurance:ccipInsurance,
        setCcipInsurance:setCcipInsurance,
        ccipInsuranceComplete:ccipInsuranceComplete,
        costAccountGroup:costAccountGroup,
        setCostAccountGroup:setCostAccountGroup,
    };


    // Checks an address for completeness
    const checkAddress = (street,city,state,zip,country) => {
        let complete = true;

        if(street.length >= 3){
            setProjectStreetComplete(true);
        }else {
            complete = false;
            setProjectStreetComplete(false);
        };
        if(city.length >= 3){
            setProjectCityComplete(true);
        }else {
            complete = false;
            setProjectCityComplete(false);
        };

        if(state.length >= 2){
            setProjectStateComplete(true);
        } else {
            complete = false;
            setProjectStateComplete(false);
        };

        if(zip.length >= 5){
            setProjectZipComplete(true);
        } else {
            complete = false;
            setProjectZipComplete(false);
        };

        if(country && country.length >= 2){
            setProjectCountryComplete(true);
        } else {
            complete = false;
            setProjectCountryComplete(false);
        };

        return complete;
    };

    const checkProjectDetails = () => {
        let complete = true;

        if(projectName.length >= 5) {
            setProjectNameError('');
            setProjectNameComplete(true);
        } else{
            complete = false;
            setProjectNameError('Please enter a project name.');
            setProjectNameComplete(false);
        };

        if(projectType === 'Project'){
        if(warrantyPeriod) {
            setWarrantyPeriodComplete(true);
        } else{
            complete = false;
            setWarrantyPeriodComplete(false);
        };

        }

        if(!checkAddress(projectStreet,projectCity,projectState,projectZip,projectCountry)){
            complete = false;
            setProjectAddressError('Please enter a valid project address.');
        } else setProjectAddressError('');

        if(taxStatus){
            setTaxStatusComplete(true);
        } else{
            complete = false;
            setTaxStatusComplete(false);
        };

        if(projectType !== 'Service'){
            if(ownerDirectPurchase ){
                setOwnerDirectPurchaseComplete(true);
            } else{
                complete = false;
                setOwnerDirectPurchaseComplete(false);
            };

            if(ccipInsurance){
                setCcipInsuranceComplete(true);
            } else{
                complete = false;
                setCcipInsuranceComplete(false);
            };

            if(intercompanyProject){
                setIntercompanyProjectComplete(true);
            } else{
                complete = false;
                setIntercompanyProjectComplete(false);
            };
        };

        if(prevailingWage){
            setPrevailingWageComplete(true);
        } else{
            complete = false;
            setPrevailingWageComplete(false);
        };

        if(bondRequired){
            setBondRequiredComplete(true);
        } else{
            complete = false;
            setBondRequiredComplete(false);
        };

        if(businessLicenseRequired){
            setBusinessLicenseRequiredComplete(true);
        } else{
            complete = false;
            setBusinessLicenseRequiredComplete(false);
        };

        if(permitsRequired){
            setPermitsRequiredComplete(true);
        } else{
            complete = false;
            setPermitsRequiredComplete(false);
        };

        if(projectState && projectState.length === 'AZ'){
            if(modification){
                setModificationComplete(true);
            } else{
                complete = false;
                setModificationComplete(false);
            };
        };

        return complete;
    };

    useEffect(() => {
        setDetailsComplete(checkProjectDetails());
    },[projectName,projectStreet,projectCity,projectState,projectZip,projectCountry,taxStatus,ownerDirectPurchase,prevailingWage,bondRequired,businessLicenseRequired,permitsRequired,ccipInsurance,warrantyPeriod,intercompanyProject]);

    // SERVICE DETAILS - - - - - - - 
    const serviceDetailProps = {
        projectName: projectName,
        setProjectName:setProjectName,
        projectNameComplete:projectNameComplete,
        projectStreet:projectStreet,
        setProjectStreet:setProjectStreet,
        projectStreetComplete:projectStreetComplete,
        projectCity:projectCity,
        setProjectCity:setProjectCity,
        projectCityComplete:projectCityComplete,
        projectState:projectState,
        setProjectState:setProjectState,
        projectStateComplete:projectStateComplete,
        projectZip:projectZip,
        setProjectZip:setProjectZip,
        projectZipComplete:projectZipComplete,
        projectCountry:projectCountry,
        setProjectCountry:setProjectCountry,
        projectCountryComplete:projectCountryComplete,
        projectCountryList:projectCountryList,
        taxStatus:taxStatus,
        setTaxStatus:setTaxStatus,
        taxStatusComplete:taxStatusComplete,
        prevailingWage:prevailingWage,
        setPrevailingWage:setPrevailingWage,
        prevailingWageComplete:prevailingWageComplete,
        bondRequired:bondRequired,
        setBondRequired:setBondRequired,
        bondRequiredComplete:bondRequiredComplete,
        businessLicenseRequired:businessLicenseRequired,
        setBusinessLicenseRequired:setBusinessLicenseRequired,
        businessLicenseRequiredComplete:businessLicenseRequiredComplete,
        permitsRequired:permitsRequired,
        setPermitsRequired:setPermitsRequired,
        permitsRequiredComplete:permitsRequiredComplete,
    };

    // CONTRACT - - - - - - - 
    const [totalContractAmount, setTotalContractAmount] = useState('');
    const [totalContractAmountComplete, setTotalContractAmountComplete] = useState(false);
    const [totalCostAmount, setTotalCostAmount] = useState('');
    const [totalCostAmountComplete, setTotalCostAmountComplete] = useState(false);
    const [defaultRetainage, setDefaultRetainage] = useState('');
    const [defaultRetainageComplete, setDefaultRetainageComplete] = useState(false);
    const [margin, setMargin] = useState(0);
    const [serviceContractList,setServiceContractList] = useState([]);
    const [contractComplete, setContractComplete] = useState(false);
    const [contractValueError, setContractValueError] = useState('');
    const [retainageError, setRetainageError] = useState('');
    const [estiamtedCostError, setEstimatedCostError] = useState('');

    const checkServiceContract = () => {
        let complete = true;

        serviceContractList.forEach(element => {
            if(!element.startDate) complete = false;
            if(!element.endDate) complete = false; 
            if(!element.billingRule) complete = false; 
            if(!element.contractAmount) complete = false;  
            if(!element.costAmount) complete = false; 
        });

        setContractComplete(complete);
    };

    const handleContractChange = (list) => {
        setServiceContractList(list)
        checkServiceContract();
    };

    const contractProps = {
        defaultRetainage:defaultRetainage,
        setDefaultRetainage:setDefaultRetainage,
        defaultRetainageComplete:defaultRetainageComplete,
        totalContractAmount:totalContractAmount,
        setTotalContractAmount:setTotalContractAmount,
        totalContractAmountComplete:totalContractAmountComplete,
        totalCostAmount:totalCostAmount,
        setTotalCostAmount:setTotalCostAmount,
        totalCostAmountComplete:totalCostAmountComplete,
        margin:margin,
        setMargin:setMargin,
        serviceContractList:serviceContractList,
        setServiceContractList:setServiceContractList,
        handleContractChange:handleContractChange,
    };

    useEffect(()  => {
        checkServiceContract();
    },[serviceContractList]);

    useEffect(() => {
        if(totalContractAmount > 0 && totalCostAmount > 0){
            let result = (((totalContractAmount-totalCostAmount)/totalContractAmount)*100);
            setMargin(result.toFixed(4));
        }
        else setMargin(0);

        let complete = true;

        if(totalContractAmount > 0){
            setTotalContractAmountComplete(true);
            setContractValueError('')
        }else{
            complete = false;
            setContractValueError('Enter a total contract amount.');
            setTotalContractAmountComplete(false);
        }

        if(totalCostAmount > 0){
            setTotalCostAmountComplete(true);
            setEstimatedCostError('');
        } else{
            complete = false;
            setEstimatedCostError('Enter an estimated cost.');
        };

        if(defaultRetainage || defaultRetainage === '0' || defaultRetainage === 0){
            setDefaultRetainageComplete(true);
            setRetainageError('')
        } else{
            complete = false;
            setRetainageError('Enter a default retainage.');
            setDefaultRetainageComplete(false);
        }

        setContractComplete(complete);

    },[totalContractAmount,totalCostAmount,defaultRetainage]);


    // Links - - - - - - - - - - - 
    const [salesLink, setSalesLink] = useState('');
    const [salesLinkComplete, setSalesLinkComplete] = useState(false);
    const [salesLinkError, setSalesLinkError] = useState('Please copy and paste the link to the sales folder');
    const [validSalesLink, setValidSalesLink] = useState(false);
    
    const validateSalesLink = () => {
        const validStart = 'https://cornerstonedetentionproducts';

        if(salesLink.startsWith(validStart)) return true;
        else return false
    };

    useEffect(() => {
        if(!salesLink){
            setSalesLinkError('Please copy and paste the link to the sales folder');
            setValidSalesLink(false);
            setSalesLinkComplete(false);
        }
        else{
            if(!validateSalesLink()){
                setSalesLinkError('Please copy a valid Box Link to Continue. To log in, navigate to www.Box.com');
                setValidSalesLink(false);
                setSalesLinkComplete(false);
            }
            else{
                setSalesLinkError('');
                setValidSalesLink(true);
                setSalesLinkComplete(true);
            }
        };
    },[salesLink]);


    // FILES - - - - - - - 
    const [filesRequired, setFilesRequired] = useState(false);
    const [filesComplete, setFilesComplete] = useState(false);
    const [contractFile, setContractFile] = useState();
    const [contractFileComplete, setContractFileComplete] = useState(false);
    const [contractFileError, setContractFileError] = useState('');
    const [prevailingWageFile, setPrevailingWageFile] = useState();
    const [prevailingWageFileComplete, setPrevailingWageFileComplete] = useState(false);
    const [bondFile, setBondFile] = useState();
    const [bondFileComplete, setBondFileComplete] = useState(false);
    const [taxExemptFile, setTaxExemptFile] = useState();
    const [certificateFile, setCertificateFile] = useState();
    const [certificateFileComplete, setCertificateFileComplete] = useState(false);
    const [prevailingWageFileError, setPrevailingWageFileError] = useState('');
    const [bondFileError, setBondFileError] = useState('');
    const [certificateFileError, setCertificateFileError] = useState('');
    const [contractFileId, setContractFileId] = useState('');
    const [contractError, setContractError] = useState('');
    const [prevailingWageFileId, setPrevailingWageFileId] = useState('');
    const [prevailingWageError, setPrevailingWageError] = useState('');
    const [bondFileId, setBondFileId] = useState('');
    const [bondError, setBondError] = useState('');
    const [taxExemptFileId, setTaxExemptFileId] = useState('');
    const [taxExemptError, setTaxExemptError] = useState('');
    const [certificateFileId, setCertificateFileId] = useState('');
    const [certificateError, setCertificateError] = useState('');
    const [financialTabFile, setFinancialTabFile] = useState();
    const [financialTabFileComplete, setFinancialTabFileComplete] = useState(false);
    const [financialTabFileError, setFinancialTabFileError] = useState('');
    const [financialTabFileId, setFinancialTabFileId] = useState('');

    useEffect(() => {
        if(contractFile) setContractFileId('');
        if(prevailingWageFile) setPrevailingWageFileId('');
        if(bondFile) setBondFileId('');
        if(taxExemptFile) setTaxExemptFileId('');
        if(certificateFile) setCertificateFileId('');

    },[contractFile,prevailingWageFile,bondFile,taxExemptFile,certificateFile]);

    const fileProps = {
        contractFile:contractFile,
        setContractFile:setContractFile,
        contractFileComplete:contractFileComplete,
        prevailingWage: prevailingWage,
        prevailingWageFile:prevailingWageFile,
        setPrevailingWageFile:setPrevailingWageFile,
        prevailingWageFileComplete:prevailingWageFileComplete,
        bondRequired:bondRequired,
        bondFile:bondFile,
        setBondFile:setBondFile,
        bondFileComplete:bondFileComplete,
        taxStatus:taxStatus,
        taxExemptFile:taxExemptFile,
        setTaxExemptFile:setTaxExemptFile,
        ccipInsurance:ccipInsurance,
        certificateFile:certificateFile,
        setCertificateFile:setCertificateFile,
        certificateFileComplete:certificateFileComplete,
        contractFileId:contractFileId,
        prevailingWageFileId:prevailingWageFileId,
        bondFileId:bondFileId,
        taxExemptFileId:taxExemptFileId,
        certificateFileId:certificateFileId,
        financialTabFile:financialTabFile,
        financialTabFileId:financialTabFileId,
        setFinancialTabFile:setFinancialTabFile,
        financialTabFileComplete:financialTabFileComplete,
        intercompanyProject:intercompanyProject,
    };
    
    const checkFilesRequired = () => {
        let complete = true;
        let filesShown = true;

        if(!contractFile && !contractFileId){
            setContractFileComplete(false);
            setContractFileError('Upload a Final Signed Contract.');
            complete = false;
        } else{
            setContractFileComplete(true);
            setContractFileError('');
        };

        // PREVAILING WAGE
        if(prevailingWage === 'true'){
            if(!prevailingWageFile && !prevailingWageFileId){
                setPrevailingWageFileComplete(false);
                setPrevailingWageFileError('Upload a Prevailing Wage Rate Sheet.');
                complete = false;
            }
            else{
                setPrevailingWageFileComplete(true);
                setPrevailingWageFileError('');
            };
        } else setPrevailingWageFileError('');

        if(intercompanyProject === 'true'){
            if(!financialTabFile && !financialTabFileId){
                setFinancialTabFileComplete(false);
                setFinancialTabFileError('Upload a Prevailing Wage Rate Sheet.');
                complete = false;
            }
            else{
                setFinancialTabFileComplete(true);
                setFinancialTabFileError('');
            };
        } else setFinancialTabFileError('');

        // BOND
        if(bondRequired === 'true'){
            filesShown = true;
            if(!bondFile && !bondFileId){
                setBondFileComplete(false);
                setBondFileError('Upload Bonding Requirements.');
                complete = false;
            } else{
                setBondFileComplete(true);
                setBondFileError('');
            };
        } else setBondFileError('');

        if(taxStatus === 'Exempt'){
        };


        if(ccipInsurance === 'true'){
            if(!certificateFile && !certificateFileId){
                setCertificateFileComplete(false);
                setCertificateFileError('Upload CCIP or OCIP Insurance Details.');
                complete = false;
            } else{
                setCertificateFileComplete(true);
                setCertificateFileError('');
            };
        }else setCertificateFileError('');

        setFilesRequired(filesShown);

        return complete;
    };

    useEffect(() => {
        setFilesComplete(checkFilesRequired());
    },[prevailingWage,bondRequired,taxStatus,prevailingWageFile,bondFile,certificateFile,taxExemptFile,certificateFileError,ccipInsurance,contractFile,financialTabFile]);

    
    // BUDGET - - - - - - - 
    const [budgetAvailable, setBudgetAvailable] = useState('');
    const [budgetImport, setBudgetImport] = useState();
    const [budgetError, setBudgetError] = useState('');
    const [budgetComplete, setBudgetComplete] = useState(false);
    const [budgetSkipReason, setBudgetSkipReason] = useState('');
    const [proestBudget, setProestBudget] = useState('');
    const [sageBudget, setSageBudget] = useState('');
    const [budgetResponse, setBudgetResponse] = useState('');
    const [serviceBudgetResponse, setServiceBudgetResponse] = useState('');
    const [budgetFiles, setBudgetFiles] = useState();
    const [taskFile, setTaskFile] = useState();
    const [revenueFile, setRevenueFile] = useState();
    const [costFile, setCostFile] = useState();
    const [taskFileId, setTaskFileId] = useState();
    const [revenueFileId, setRevenueFileId] = useState();
    const [costFileId, setCostFileId] = useState();
    const [taskFileError, setTaskFileError] = useState();
    const [revenueFileError, setRevenueFileError] = useState();
    const [costFileError, setCostFileError] = useState();

    const [budgetResponseErrors, setBudgetResponseErrors] = useState();

    const [serviceCostBudgetTemplate, setServiceCostBudgetTemplate] = useState('');
    const [serviceCostFile, setServiceCostFile] = useState();
    const [serviceFilesComplete, setServiceFilesComplete] = useState(false);
    const [serviceCostFileError, setServiceCostFileError] = useState();
    const [serviceTaskFilename, setServiceTaskFilename] = useState();
    const [serviceRevenueFilename, setServiceRevenueFilename] = useState();
    const [serviceCostFilename, setServiceCostFilename] = useState();

    useEffect(() => {
        if(budgetResponse){
            if(budgetResponse.totalCost != totalCostAmount) setBudgetResponseErrors('Total Estimated Cost provided in contract details does not match the total of the list provided.');
            else setBudgetResponseErrors(null);
        }
        else setBudgetResponseErrors(null);

    },[budgetResponse, totalCostAmount]);

    const clearBudget = () => {
        setServiceCostFile(null);
        setServiceBudgetResponse(null);
        setBudgetFiles(null);
    };

    const refreshBudgetTotals = () => {
        setBudgetComplete(checkBudget());
    };

    const checkBudget = () => {
        let complete = true;

        // BUDGET
        if(!budgetAvailable && !budgetFiles){
            if(projectType === 'Service'){
                if(!serviceBudgetResponse){
                    setBudgetError('Please download, format, and upload a service budget.');
                    complete = false;
                }
                else setBudgetError('');
            }
            else{
                setBudgetError('Please select a budget type.');
                complete = false;
            };
        };

        if(budgetAvailable === 'Standard'){
            console.log('Checking Standard Budget');
            if(!budgetResponse && !budgetFiles) {
                setBudgetError('Upload a standard budget.');
                complete = false;
            }
            else{
                if(budgetResponse && budgetResponse.errorList > 0) complete = false;
                else setBudgetError('');
            }
        };

        if(budgetAvailable === 'ProEst'){
            if(!proestBudget) {
                setBudgetError('Provide enter a valid ProEst estimate number.');
                complete = false;
            }
            else setBudgetError('');
        };

        if(budgetAvailable === 'Sage'){
            if(!sageBudget) {
                setBudgetError('Provide a sage estimate number.');
                complete = false;
            }
            else setBudgetError('');
        };

        if(budgetAvailable === 'None'){
            if(budgetSkipReason.length < 5){
                setBudgetError('Provide a valid reason for skipping the budget.');
                complete = false;
            }
            else setBudgetError('');
        };

        if(budgetAvailable === 'Service'){
            console.log(budgetFiles);
            console.log('We Got Here');
            if(!serviceCostFile && !budgetFiles){ 
                console.log('No service budget file');
                setBudgetError('Upload a service budget.');
                complete = false;
            }
            else{
                setBudgetError('');
                if(serviceBudgetResponse){
                    console.log('Service Budget Response', serviceBudgetResponse);
                    let tempBudgetError = '';
                    Object.keys(serviceBudgetResponse.stats).forEach((key) => {
                        // I want to remove the first 4 digits from the key
                        const newKey = key.substring(4);
                        if(Number(serviceContractList[Number(newKey)-1].costAmount) !== serviceBudgetResponse.stats[key].amount){
                            tempBudgetError += `The cost amount for ${serviceContractList[Number(newKey)-1].contractYear} does not match the budgeted amount. `;
                            complete = false;
                        }
                    });

                    setBudgetError(tempBudgetError);
                }
                else{
                    if(!budgetFiles) {
                        setBudgetError('Upload a service budget.');
                        complete = false;
                    }

                }
            };
        };

        return complete;
    };

    useEffect(() => {
        refreshBudgetTotals();
    },[budgetSkipReason,budgetAvailable,proestBudget,budgetResponse,serviceCostFile,serviceBudgetResponse,sageBudget,serviceContractList,budgetFiles]);

    useEffect(() => {
        if(serviceCostFile){
            setServiceCostFileError('');
            setBudgetFiles();
            const extension = serviceCostFile[0].type
            const filename = `${projectName}-Original Budget-${getDate()}.xlsx`;
            sendServiceBudget(contextObject.apiToken, serviceCostFile, filename, setServiceBudgetResponse, setServiceCostFileError);
        }
        else{
            setBudgetResponse(null);
        }
    },[serviceCostFile]);

    // Formats budget when uploaded
    const importProjectBudget = () => {
        setBudgetFiles();
        const extension = budgetImport[0].type
        const filename = `${projectName}-Original Budget-${getDate()}.xlsx`;
        sendProjectBudget(contextObject.apiToken, budgetImport, filename, setBudgetResponse, setBudgetError);
    };

    // Do this when a budget import is selected
    useEffect(() => {
        if(!budgetResponse && budgetImport) importProjectBudget();
    },[budgetImport]);

    const openProjectBookingTask = async (token, fileName) => {
        newProjectBookingDataService.getBudgetFile(token,fileName);
    };

    const openProjectBookingRevenue = async (token, fileName) => {
        newProjectBookingDataService.getBudgetFile(token,fileName);
    };

    const openProjectBookingCost = async (token, fileName) => {
        newProjectBookingDataService.getBudgetFile(token,fileName);
    };

    // SUBMITTING - - - - - - - 
    const [submitting, setSubmitting] = useState(false);
    const [completeSubmission, setCompleteSubmission] = useState('');
    const [completionError, setCompletionError] = useState('');
    const [notes, setNotes] = useState('');
    let submittingCheck = false;

    const createProjectBookingObject = () => {
        let tempStreet2 = '';
        if(projectStreet2) tempStreet2 = projectStreet2.replace(/[^a-zA-Z0-9\s]/g, '')

        const projectAddress = {
            street: projectStreet.replace(/[^a-zA-Z0-9\s]/g, ''),
            street2: tempStreet2,
            city: projectCity.replace(/[^a-zA-Z0-9\s]/g, ''),
            state: projectState.replace(/[^a-zA-Z0-9\s]/g, ''),
            zip: projectZip.replace(/[^a-zA-Z0-9\s]/g, ''),
            country: projectCountry.replace(/[^a-zA-Z0-9\s]/g, ''),
        };

        let tempEntityName = '';
        if(entityName) tempEntityName = entityName.replace(/[^a-zA-Z0-9\s]/g, '');

        let tempPoNumber = '';
        if(customerPoNumber) tempPoNumber = customerPoNumber.replace(/[^a-zA-Z0-9\s]/g, '');

        let tempBudgetSkipReason = '';
        if(budgetSkipReason) tempBudgetSkipReason = budgetSkipReason.replace(/[^a-zA-Z0-9\s]/g, '');

        const budget = {
            type: budgetAvailable,
            text: budgetSkipReason,
            estimateNumber: proestBudget,
            sageEstimateNumber: sageBudget,
        };

        const projectBookingObject = {
            customer:customerSelected,
            location:locationSelected,
            entityName: tempEntityName,
            customerPoNumber:tempPoNumber,
            warrantyPeriod:warrantyPeriod ? Number(warrantyPeriod) : null,

            branch:branch,
            projectManager:projectManager,

            projectType:projectType,

            projectName:projectName.replace(/[^a-zA-Z0-9\s]/g, ''),
            projectAddress: projectAddress,

            taxStatus,taxStatus,

            ownerDirectPurchase:`${ownerDirectPurchase === 'true' ? true : false}`,
            intercompanyProject:`${intercompanyProject === 'true' ? true : false}`,
            prevailingWage:`${prevailingWage === 'true' ? true : false}`,
            bondRequired:`${bondRequired === 'true' ? true : false}`,
            businessLicenseRequired:`${businessLicenseRequired === 'true' ? true : false}`,
            permitsRequired:`${permitsRequired === 'true' ? true : false}`,
            modification:`${modification === 'true' ? true : false}`,
            ccipInsurance: `${ccipInsurance === 'true' ? true : false}`,

            salesLink:salesLink,

            totalContractAmount:totalContractAmount,
            totalCostAmount:totalCostAmount,
            margin:margin,
            defaultRetainage:defaultRetainage,

            contractFileId:contractFileId,
            prevailingWageFileId:prevailingWageFileId,
            bondFileId:bondFileId,
            taxExemptFileId:taxExemptFileId,
            certificateFileId:certificateFileId,
            financialTabFileId:financialTabFileId,
            
            budget:budget,
            budgetResponse:budgetResponse,
            budgetSkipReason:tempBudgetSkipReason,

            submittingUser: contextObject.activeUser.id,

            notes:notes
        };

        if(projectType === 'Service'){
            projectBookingObject.totalContractAmount = 0;
            projectBookingObject.totalCostAmount = 0;
            projectBookingObject.margin = 0;
            projectBookingObject.defaultRetainage = 0;
            projectBookingObject.serviceContractList = serviceContractList;
            projectBookingObject.budget.type = "Standard";
            projectBookingObject.budget.taskFileName = serviceTaskFilename;
            projectBookingObject.budget.revenueFileName = serviceRevenueFilename;
            projectBookingObject.budget.costFileName = serviceCostFilename;
        };

        return projectBookingObject
    };

    const createUpdateProjectBookingObject = () => {
        const updatedRecord = rejectionRecord;

        updatedRecord.resubmit = true;
        updatedRecord.rejectionId = rejectionSelected.rejectionId;
        // Customer
        updatedRecord.customer.class = customerSelected.class;
        updatedRecord.customer.customerId = customerSelected.customerId;
        updatedRecord.customer.name = customerSelected.name;
        // Location
        updatedRecord.location = updatedRecord.customer.location;
        updatedRecord.location.locationId = locationSelected.locationId;
        updatedRecord.location.locationName = locationSelected.locationName;
        updatedRecord.location.status = locationSelected.status;
        // Location Address
        updatedRecord.location.address.street = locationSelected.address.street;
        updatedRecord.location.address.street2 = locationSelected.address.street2;
        updatedRecord.location.address.city = locationSelected.address.city;
        updatedRecord.location.address.state = locationSelected.address.state;
        updatedRecord.location.address.zip = locationSelected.address.zip;
        updatedRecord.location.address.country = locationSelected.address.country;
        // Name / Type
        updatedRecord.projectName = projectName.replace(/[^a-zA-Z0-9\s]/g, '');
        updatedRecord.projectType = projectType;
        // Branch / PM
        updatedRecord.branch = branch;
        updatedRecord.projectManager = projectManager;
        // Entity / Po Number
        if(entityName) updatedRecord.entityName = entityName.replace(/[^a-zA-Z0-9\s]/g, '');
        else updatedRecord.entityName = null
        if(customerPoNumber) updatedRecord.customerPoNumber = customerPoNumber.replace(/[^a-zA-Z0-9\s]/g, '');
        else updatedRecord.customerPoNumber = null;
        updatedRecord.warrantyPeriod = warrantyPeriod;
        // Project Address
        updatedRecord.address.street = projectStreet.replace(/[^a-zA-Z0-9\s]/g, '');
        if(projectStreet2) updatedRecord.address.street2 = projectStreet2.replace(/[^a-zA-Z0-9\s]/g, '');
        else updatedRecord.address.street2 = null;
        updatedRecord.address.city = projectCity.replace(/[^a-zA-Z0-9\s]/g, '');
        updatedRecord.address.state = projectState.replace(/[^a-zA-Z0-9\s]/g, '');
        updatedRecord.address.zip = projectZip.replace(/[^a-zA-Z0-9\s]/g, '');
        updatedRecord.address.country = projectCountry ? projectCountry.replace(/[^a-zA-Z0-9\s]/g, '') : null;
        // Required
        updatedRecord.bondRequired = bondRequired === 'true' ? true : false;
        updatedRecord.businessLicenseRequired = businessLicenseRequired === 'true' ? true : false;
        updatedRecord.ownerDirectPurchase = ownerDirectPurchase === 'true' ? true : false;
        updatedRecord.prevailingWage = prevailingWage === 'true' ? true : false;
        updatedRecord.permitsRequired = permitsRequired === 'true' ? true : false;
        updatedRecord.modification = modification === 'true' ? true : false;
        updatedRecord.ccipInsurance = ccipInsurance === 'true' ? true : false;
        // Contract
        updatedRecord.totalContractAmount = totalContractAmount;
        updatedRecord.totalCostAmount = totalCostAmount;
        updatedRecord.margin = margin;
        updatedRecord.defaultRetainage = defaultRetainage;
        updatedRecord.taxStatus = taxStatus;
        updatedRecord.serviceContractList = serviceContractList;
        // Notes
        if(notes) updatedRecord.notes = notes.replace(/[^a-zA-Z0-9\s]/g, '');
        else updatedRecord.notes = null;
        // Links
        updatedRecord.salesLink = salesLink;
        // Files
        updatedRecord.contract = contractFileId;
        updatedRecord.rateSheet = prevailingWageFileId;
        updatedRecord.ocip = certificateFileId;
        updatedRecord.bonding = bondFileId;
        updatedRecord.taxExemption = taxExemptFileId;
        updatedRecord.financialTab = financialTabFileId;
        // Budget
        const budget = {
            id: updatedRecord.budget.id,
            type: budgetAvailable,
            text: budgetSkipReason,
            estimateNumber: sageBudget,
            taskFileName: budgetFiles ? budgetFiles.task : null,
            revenueFileName: budgetFiles ? budgetFiles.revenue : null,
            costFileName: budgetFiles ? budgetFiles.cost : null,
        };

        updatedRecord.budgetResponse = budgetResponse;
        updatedRecord.budget = budget;

        if(projectType === 'Service'){
            updatedRecord.totalContractAmount = 0;
            updatedRecord.totalCostAmount = 0;
            updatedRecord.margin = 0;
            updatedRecord.defaultRetainage = 0;
            updatedRecord.serviceContractList = serviceContractList;
            updatedRecord.budget.type = "Standard";
            updatedRecord.budget.taskFileName = serviceTaskFilename;
            updatedRecord.budget.revenueFileName = serviceRevenueFilename;
            updatedRecord.budget.costFileName = serviceCostFilename;
        };

        return updatedRecord;
    };

    const submitFiles = () => {
        setSubmitting(true);

        if(contractFile) sendContractFile(contextObject.apiToken,contractFile[0],`${projectName.replace(/[^a-zA-Z0-9\s]/g, '')}-Contract-${getDate()}.${contractFile[0].type.replace(/(.*)\//g, '')}`,setContractFileId,setContractError);
        if(prevailingWageFile) sendPrevailingWageFile(contextObject.apiToken,prevailingWageFile[0],`${projectName.replace(/[^a-zA-Z0-9\s]/g, '')}-Rate Sheet-${getDate()}.${prevailingWageFile[0].type.replace(/(.*)\//g, '')}`,setPrevailingWageFileId,setPrevailingWageError);
        if(bondFile) sendBondFile(contextObject.apiToken,bondFile[0],`${projectName.replace(/[^a-zA-Z0-9\s]/g, '')}-Bonding Requirements-${getDate()}.${bondFile[0].type.replace(/(.*)\//g, '')}`,setBondFileId,setBondError);
        if(taxExemptFile) sendTaxExemptFile(contextObject.apiToken,taxExemptFile[0],`${projectName.replace(/[^a-zA-Z0-9\s]/g, '')}-Tax Exemption-${getDate()}.${taxExemptFile[0].type.replace(/(.*)\//g, '')}`,setTaxExemptFileId,setTaxExemptError);
        if(certificateFile) sendCertificateFile(contextObject.apiToken,certificateFile[0],`${projectName.replace(/[^a-zA-Z0-9\s]/g, '')}-OCIP CCIP-${getDate()}.${certificateFile[0].type.replace(/(.*)\//g, '')}`,setCertificateFileId,setCertificateError);
        if(financialTabFile) sendFinancialTabFile(contextObject.apiToken,financialTabFile[0],`${projectName.replace(/[^a-zA-Z0-9\s]/g, '')}-Intercompany Breakout-${getDate()}.${'xlsx'}`,setFinancialTabFileId,setFinancialTabFileError);

        if(taskFile) sendTaskFile(contextObject.apiToken,taskFile[0],`${projectName.replace(/[^a-zA-Z0-9\s]/g, '')}`,setTaskFileId,setTaskFileError);
        if(revenueFile) sendRevenueFile(contextObject.apiToken,revenueFile[0],`${projectName.replace(/[^a-zA-Z0-9\s]/g, '')}`,setRevenueFileId,setRevenueFileError);
        if(costFile) sendCostFile(contextObject.apiToken,costFile[0],`${projectName.replace(/[^a-zA-Z0-9\s]/g, '')}`,setCostFileId,setCostFileError);

        if(serviceCostFile) sendServiceCostFile(contextObject.apiToken,serviceCostFile[0],`${projectName.replace(/[^a-zA-Z0-9\s]/g, '')}`,setServiceTaskFilename,setServiceRevenueFilename,setServiceCostFilename,setServiceFilesComplete,serviceContractList,setServiceCostFileError)

        if(!contractFile && !prevailingWageFile && !bondFile && !taxExemptFile && !certificateFile && !taskFile && !revenueFile && !costFile && !serviceCostFile && !financialTabFile){
            submittingCheck = true;
            if(!rejectionSelected) sendProjectBookingRequest(contextObject.apiToken,createProjectBookingObject(),setCompleteSubmission,setCompletionError);
            else updateProjectBookingRequest(contextObject.apiToken,createUpdateProjectBookingObject(),setCompleteSubmission,setCompletionError);
        } 
    };

    const checkFormComplete = () => {
        let readyToSubmit = true;

        if(!customerSelected) readyToSubmit = false;
        if(!locationSelected) readyToSubmit = false;
        if(!branchAndManagerComplete) readyToSubmit = false;
        if(!contractComplete) readyToSubmit = false;
        if(!validSalesLink) readyToSubmit = false;
        if(!filesComplete) readyToSubmit = false;
        if(!budgetComplete) readyToSubmit = false;
        if(budgetResponseErrors) readyToSubmit = false;

        return(readyToSubmit);
    };

    const checkFilesComplete = () => {
        let readyToSubmit = true;

        if(!checkFormComplete()) readyToSubmit = false;
        if(contractFile && !contractFileId) readyToSubmit = false;
        if(prevailingWageFile && !prevailingWageFileId) readyToSubmit = false;
        if(bondFile && !bondFileId) readyToSubmit = false;
        if(taxExemptFile && !taxExemptFileId) readyToSubmit = false;
        if(certificateFile && !certificateFileId) readyToSubmit = false;
        if(financialTabFile && !financialTabFileId) readyToSubmit = false;

        if(taskFile && !taskFileId) readyToSubmit = false;
        if(revenueFile && !revenueFileId) readyToSubmit = false;
        if(costFile && !costFileId) readyToSubmit = false;

        if(serviceCostFile && !serviceTaskFilename) readyToSubmit = false;
        if(serviceCostFile && !serviceRevenueFilename) readyToSubmit = false;
        if(serviceCostFile && !serviceCostFilename) readyToSubmit = false;
        
        return(readyToSubmit);
    };

    useEffect(() => {
        if(checkFilesComplete() && !submittingCheck && !rejectionSelected){
            submittingCheck = true;
            sendProjectBookingRequest(contextObject.apiToken,createProjectBookingObject(),setCompleteSubmission,setCompletionError);
        }
        else if(checkFilesComplete() && !submittingCheck && rejectionSelected){
            submittingCheck = true;
            updateProjectBookingRequest(contextObject.apiToken,createUpdateProjectBookingObject(),setCompleteSubmission,setCompletionError);
        };
    },[contractFileId,prevailingWageFileId,bondFileId,taxExemptFileId,certificateFileId,taskFileId,revenueFileId,costFileId,financialTabFileId,serviceFilesComplete]);

    // REJECTION - - - - - - - 
    const [rejectionList, setRejectionList] = useState();
    const [rejectionSelected, setRejectionSelected] = useState();
    const [rejectionRecord, setRejectionRecord] = useState();

    useEffect(() => {
        newProjectBookingDataService.getRejectedList(contextObject.apiToken,contextObject.activeUser.id).then(res => setRejectionList(res.data.rejection))
    },[]);

    const clearForm = () => {
        setRejectionRecord(null);
        setCustomerSelected(null);
        setLocationSelected(null);
        setEntityName('');
        setCustomerPoNumber('');
        setBranch('');
        setProjectManager('');
        setBranchAndManagerComplete(false);
        setProjectName('');
        setProjectStreet('');
        setProjectStreet2('');
        setProjectCity('');
        setProjectState('');
        setProjectZip('');
        setProjectCountry('');
        setOwnerDirectPurchase(false);
        setPrevailingWage(false);
        setBondRequired(false);
        setBusinessLicenseRequired(false);
        setPermitsRequired(false);
        setCcipInsurance(false);
        setBillingType('Progressive');
        setTaxStatus('Contractor');
        setDetailsComplete(false);
        setTotalContractAmount(0);
        setTotalCostAmount(0);
        setMargin(0);
        setDefaultRetainage(0);
        setServiceContractList([]);
        setContractComplete(false);
        setSalesLink('');
        setFilesRequired(false);
        setFilesComplete(false);
        setContractFileId('');
        setPrevailingWageFileId('');
        setBondFileId('');
        setTaxExemptFileId('');
        setCertificateFileId('');
        setBudgetAvailable('');
        setBudgetSkipReason('');
    };

    const populateForm = (record) => {
        if(record.projectType === 'Service') {
            getServiceContracts(contextObject.apiToken,record.id,setServiceContractList,setContractValueError);
            setBudgetAvailable('Service');
        };
        setRejectionRecord(record);
        setProjectRequired(true);
        setCustomerSelected(record.customer);
        setLocationSelected(record.customer.location);
        if(record.entityName) setEntitySelection(false);
        setEntityName(record.entityName);
        setCustomerPoNumber(record.poNumber);
        setWarrantyPeriod(record.warrantyPeriod);
        setBranch(record.branch);
        setProjectManager(record.projectManager);
        setBranchAndManagerComplete(true);
        setProjectName(record.name);
        setProjectStreet(record.address.street);
        setProjectStreet2(record.address.street2);
        setProjectCity(record.address.city);
        setProjectState(record.address.state);
        setProjectZip(record.address.zip);
        setProjectCountry(record.address.country);
        setProjectType(record.projectType);
        setOwnerDirectPurchase(record.ownerDirect ? 'true' : 'false');
        setIntercompanyProject(record.intercompanyProject ? 'true' : 'false');
        setPrevailingWage(record.prevailingWage ? 'true' : 'false');
        setBondRequired(record.bondRequired ? 'true' : 'false');
        setBusinessLicenseRequired(record.businessLicense ? 'true' : 'false');
        setPermitsRequired(record.permitsRequired ? 'true' : 'false');
        setModification(record.modification ? 'true' : 'false');
        setCcipInsurance(record.ccipInsturance ? 'true' : 'false');
        setBillingType('Progressive');
        setTaxStatus(record.taxStatus);
        setDetailsComplete(true);
        setTotalContractAmount(record.contractAmount);
        setTotalCostAmount(record.costAmount);
        setMargin(record.margin);
        setDefaultRetainage(record.defaultRetainage);
        setServiceContractList([]);
        setContractComplete(true);
        setSalesLink(record.salesLink);
        setFilesRequired(true);
        setFilesComplete(true);
        setContractFileId(record.contract);
        if(record.rateSheet) setPrevailingWageFileId(record.rateSheet);
        if(record.bonding) setBondFileId(record.bonding);
        if(record.taxExemption) setTaxExemptFileId(record.taxExemption);
        if(record.ocip) setCertificateFileId(record.ocip);
        if(record.financialTab) setFinancialTabFileId(record.financialTab);

        if(record.budget){
            if(record.budget.type === 'None'){
                setBudgetAvailable('None');
                setBudgetSkipReason(record.budget.text);
            };
            if(record.budget.type === 'Sage'){
                setBudgetAvailable('Sage');
                setSageBudget(record.budget.estimateNumber);
            };
            if(record.budget.type === 'Standard'){
                console.log('Setting Standard Budget', record.projectType);
                if(record.projectType !== 'Service') setBudgetAvailable('Standard');
                else setBudgetAvailable('Service');
                const budgetFiles = {
                    task: record.budget.taskFileName,
                    revenue: record.budget.revenueFileName,
                    cost: record.budget.costFileName,
                }
                setBudgetFiles(budgetFiles);
            };
        };

        setNotes(record.notes);
    };

    const getForm = (id) => {
        rejectionList.forEach(element => {
            if(element.recordId === id) setRejectionSelected(element);
        });
        newProjectBookingDataService.getRecord(contextObject.apiToken,id).then(res => populateForm(res.data.record));
    };

    const cancelRejection = () => {
        setRejectionSelected(null);
        clearForm();
    };

    const generateServiceContractTemplate = () => {
        createServiceContractTemplate(contextObject.apiToken,serviceContractList,setServiceCostBudgetTemplate);
        setBudgetAvailable('Service');
    };

    const clearBudgetFiles = () => {
        setBudgetFiles(null);
        setBudgetError(null);
        setBudgetResponse(null);
        setBudgetImport(null);
        refreshBudgetTotals();
    };

    // MAIN DISPLAY - - - - - - - 
    return(
        <div className='Project-Booking'>
            { !submitting &&
                <div className='project-Booking-Form'>
                    {   rejectionList && rejectionList.length > 0 &&
                        <div className='Project-Booking-Section'>
                            <RejectionWindow rejectionList={rejectionList} getForm={getForm} rejectionSelected={rejectionSelected} cancelRejection={cancelRejection}/>
                        </div>
                    }

                    {   !projectRequired &&
                        <div className='Project-Booking-Section'>
                            <ProjectRequiredForm projectRequired={projectRequired} setProjectRequired={setProjectRequired}/>
                        </div>
                    }

                    {
                        <div className='Project-Booking-Warning'>
                            <div className='Project-Booking-Warning-Text'>
                                This form does not save automatically - do not close the page until you have submitted.
                            </div>
                        </div>    
                    }

                    {   projectRequired &&    // CUSTOMER
                        <div className='Project-Booking-Section'>
                            <CustomerSelector apiToken={contextObject.apiToken} customerSelected={customerSelected} setCustomerSelected={setCustomerSelected} locationSelected={locationSelected} setLocationSelected={setLocationSelected}/>

                            {   customerSelected &&
                                <div className='Project-Booking-Input-Form'>
                                    <SelectInputField title={'Entity Name on Contract or PO same as Customer'} value={entitySelection} setTo={setEntitySelection} options={[{text:'Yes', value:true},{text:'No',value:false}]}/>
                                    { enitityShown &&
                                    <StandardInputField title={'Entity Name on Contract or PO'} value={entityName} setTo={setEntityName}/>
                                    }
                                    <StandardInputField title={'Customer Contract/PO Number'} value={customerPoNumber} setTo={setCustomerPoNumber}/>
                                </div>
                            }
                        </div>
                    }

                    {   customerSelected &&  locationSelected && // BRANCH & MANAGER
                        <div className='Project-Booking-Section'>
                            <div className='Project-Booking-Section-Title'>Branch & Manager Details</div>
                            <div className='Project-Booking-Input-Form'>
                                <BranchManagementForm {...branchManagementProps}/>
                            </div>
                        </div>
                    }
                    
                    {   customerSelected &&  locationSelected && branchAndManagerComplete &&  // PROJECT TYPE
                        <div className='Project-Booking-Section'>
                            <div className='Project-Booking-Section-Title'>Type</div>
                            <div className='Project-Booking-Input-Form'>
                                <ProjectTypeForm projectType={projectType} setProjectType={setProjectType} projectTypeComplete={projectTypeComplete}/>
                            </div>
                        </div>
                    }

                    {   customerSelected &&  locationSelected && branchAndManagerComplete && projectType === 'Project' &&  // PROJECT DETAILS
                        <div className='Project-Booking-Section'>
                            <div className='Project-Booking-Section-Title'>Project Details</div>
                            <div className='Project-Booking-Input-Form'>
                                <ProjectDetailsForm {...projectDetailProps}/>
                            </div>
                        </div>
                    }

                    {   customerSelected &&  locationSelected && branchAndManagerComplete && projectType === 'Project' && detailsComplete && // PROJECT CONTRACT
                        <div className='Project-Booking-Section'>
                            <div className='Project-Booking-Section-Title'>Contract Details</div>
                            <div className='Project-Booking-Input-Form'>
                                <ProjectContractForm {...contractProps}/>
                            </div>
                        </div>
                    }

                    {   customerSelected &&  locationSelected && branchAndManagerComplete && projectType === 'Service' && // SERVICE DETAILS
                        <div className='Project-Booking-Section'>
                            <div className='Project-Booking-Section-Title'>Service Details</div>
                            <div className='Project-Booking-Input-Form'>
                                <ServiceDetailsForm {...serviceDetailProps}/>
                            </div>
                        </div>
                    }

                    {   customerSelected &&  locationSelected && branchAndManagerComplete && projectType === 'Service' && detailsComplete && // SERVICE CONTRACT
                        <div className='Project-Booking-Section'>
                            <div className='Project-Booking-Section-Title'>Service Contract Details</div>

                            <ServiceContractForm {...contractProps}/>
                            {   !contractComplete &&
                                <div className='Project-Booking-Error-Line'>Please fill out the service contract information to continue. Fill out the first year before adding additional as it will fill out the majority of fields.</div>
                            }
                        </div>
                    }

                    {   customerSelected &&  locationSelected && branchAndManagerComplete && contractComplete && // LINKS  
                        <LinkForm salesLink={salesLink} setSalesLink={setSalesLink} salesLinkComplete={salesLinkComplete}/> 
                    }

                    {   customerSelected &&  locationSelected && branchAndManagerComplete && validSalesLink && filesRequired && // FILES
                        <div className='Project-Booking-Section'> 
                            <div className='Project-Booking-Section-Title'>Required Files</div>
                            <div className='Project-Booking-Input-Form'>
                                <FilesForm {...fileProps}/>
                            </div>
                        </div>
                    }
                    
                    {   customerSelected &&  locationSelected && branchAndManagerComplete && validSalesLink && filesComplete && projectType === 'Project' && // PROJECT BUDGET
                        <div className='Project-Booking-Section'>
                            <div className='Project-Booking-Section-Title'>Budget Information</div>
                            <div className='Project-Booking-Input-Form'>
                                <SelectInputField title={'What type of Budget would you like to upload?'} value={budgetAvailable} setTo={setBudgetAvailable} options={[{text:'Standard', value:'Standard'},{text:'Sage Estimating',value:'Sage'},{text:"I don't have a budget",value:'None'}]}/>
                            </div>
                        
                        {   budgetAvailable === 'Standard' && // STANDARD BUDGET
                            <div className='Project-Booking-Budget'>
                            {   !budgetImport &&
                            <>
                                <div className='Project-Booking-Budget-Import'>
                                    <div className='Project-Booking-Budget-Import-Instructions'>
                                        Please upload a Standard Budget. 
                                    </div>

                                    <div className='Project-Booking-Budget-Import-Controls'>
                                        <button className='Project-Booking-Budget-Import-Template' onClick={ () => getBudgetTemplate() }>Download Template</button>
                                        <input type='file' accept=".xls,.xlsx" onChange={(e) => setBudgetImport(e.target.files)}className='Project-Booking-Budget-Import-Upload'/>
                                    </div>
                                </div>
                            </>
                            }

                            {   budgetFiles && 
                            <div className='Project-Booking-Budget-Files'>
                                <div className='Project-Booking-File-Update'>
                                    A budget has already been uploaded. Choosing a new file above will overwrite the stored versions.
                                </div>

                                <div className='Project-Booking-Budget-Files-Tray'>
                                    <button className='Record-Sales-Link' onClick={() => openProjectBookingTask(contextObject.apiToken,budgetFiles.task)}>Download Tasks</button>
                                    <button className='Record-Sales-Link' onClick={() => openProjectBookingRevenue(contextObject.apiToken,budgetFiles.revenue)}>Download Revenue Budget</button>
                                    <button className='Record-Sales-Link' onClick={() => openProjectBookingCost(contextObject.apiToken,budgetFiles.cost)}>Download Cost Budget</button>
                                </div>
                            {/*
                                <div className='Project-Booking-Budget-File-Upload'>
                                    <div className='Project-Booking-Budget-File-Title'>Update Task File</div>
                                    <input type='file' accept=".xls,.xlsx" onChange={(e) => setTaskFile(e.target.files)}className='Project-Booking-Budget-File-Input'/>
                                </div>

                                <div className='Project-Booking-Budget-File-Upload'>
                                    <div className='Project-Booking-Budget-File-Title'>Update Revenue File</div>
                                    <input type='file' accept=".xls,.xlsx" onChange={(e) => setRevenueFile(e.target.files)}className='Project-Booking-Budget-File-Input'/>
                                </div>
                                <div className='Project-Booking-Budget-File-Upload'>
                                    <div className='Project-Booking-Budget-File-Title'>Update Cost File</div>
                                    <input type='file' accept=".xls,.xlsx" onChange={(e) => setCostFile(e.target.files)}className='Project-Booking-Budget-File-Input'/>
                                </div>
                            */}


                            </div>
                            }

                            {   budgetImport && !budgetResponse &&
                                <LoadingSpinner size={60}/>
                            }

                            {   budgetResponse && !budgetError &&
                            <>
                                <button onClick={() => clearBudgetFiles()}>Clear Budget</button>
                                <BudgetComponent budgetResponse={budgetResponse} budgetResponseErrors={budgetResponseErrors}/>
                            </>
                            }
                            </div>
                        }

                        {   budgetAvailable === 'ProEst' && // PROEST BUDGET
                            <div className='Project-Booking-Budget'>
                                <StandardInputField title={'ProEst Estimate Number'} value={proestBudget} setTo={setProestBudget} width={250}/>
                            </div>
                        }

                        {   budgetAvailable === 'Sage' && // Sage BUDGET
                            <div className='Project-Booking-Budget'>
                                <StandardInputField title={'Sage Estimate Number'} value={sageBudget} setTo={setSageBudget} width={250}/>
                            </div>
                        }

                        {   budgetAvailable === 'None' && // NO BUDGET
                            <>
                            <div className='Project-Booking-Section-Title'>Reason for Skipping Budget</div>
                            <BudgetSkipForm budgetSkipReason={budgetSkipReason} setBudgetSkipReason={setBudgetSkipReason}/>
                            </>
                        }

                        { budgetError &&
                            <div className='Project-Booking-Error'>
                                <div className='Project-Booking-Error-Line'>{budgetError}</div>
                            </div>
                        }
                        </div>
                    }

                    {   customerSelected &&  locationSelected && branchAndManagerComplete && validSalesLink && filesComplete && projectType === 'Service' && // SERVICE BUDGET
                        <div className='Project-Booking-Section'>
                            <div className='Project-Booking-Section-Title'>Service Budget</div>
                            <div className='Project-Booking-Input-Form'>
                                {   !budgetFiles &&
                                    <ServiceBudgetComponent generateServiceContractTemplate={generateServiceContractTemplate} serviceCostBudgetTemplate={serviceCostBudgetTemplate} setServiceCostFile={setServiceCostFile} budgetResponse={serviceBudgetResponse} 
                                    budgetError={budgetError} clearBudget={clearBudget} refreshBudgetTotals={refreshBudgetTotals}/>
                                }

                                {   budgetFiles && 
                                <div className='Project-Booking-Budget-Files'>
                                    <div className='Project-Booking-File-Update'>
                                        A budget has already been uploaded. Clear this budget to upload a new one.
                                        <button onClick={() => clearBudgetFiles()}>Clear Budget</button>
                                    </div>

                                    <div className='Project-Booking-Budget-Files-Tray'>
                                        <button className='Record-Sales-Link' onClick={() => openProjectBookingTask(contextObject.apiToken,budgetFiles.task)}>Download Tasks</button>
                                        <button className='Record-Sales-Link' onClick={() => openProjectBookingRevenue(contextObject.apiToken,budgetFiles.revenue)}>Download Revenue Budget</button>
                                        <button className='Record-Sales-Link' onClick={() => openProjectBookingCost(contextObject.apiToken,budgetFiles.cost)}>Download Cost Budget</button>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    }

                    {   checkFormComplete() && // NOTES
                        <div className='Project-Booking-Section'>
                            <div className='Project-Booking-Section-Title'>Additional Notes</div>
                            <div className='Project-Booking-Input-Form'>
                                <div className='Project-Booking-Skip-Budget'>
                                    <textarea className='Project-Booking-Skip-Budget-Input' value={notes} onChange={e => setNotes(e.target.value)} placeholder="Enter any additional notes or comments here..." />
                                </div>  
                            </div>                      
                        </div>
                    }

                    {   checkFormComplete() && // SUBMIT BUTTON
                        <div className='Project-Booking-Submit'> 
                            { !rejectionSelected &&
                                <button className='Project-Booking-Submit-Button' onClick={() => submitFiles()}>Submit Project Booking Request</button>
                            }
                            { rejectionSelected &&
                                <button className='Project-Booking-Submit-Button' onClick={() => submitFiles()}>Update Project Booking Request</button>
                            }
                        </div>
                    }
                </div>
            }

            {   submitting &&
                <div className='modern-submission-overlay'>
                    <div className='modern-submission-modal'>
                        <div className='modern-submission-header'>
                            <div className='modern-submission-icon'>
                                📋
                            </div>
                            <h2 className='modern-submission-title'>
                                Submitting Project Booking Request
                            </h2>
                            <p className='modern-submission-subtitle'>
                                Please wait while we process your submission...
                            </p>
                        </div>

                        <div className='modern-submission-progress'>
                            <div className='modern-submission-steps'>
                                {   contractFile &&
                                    <div className={`modern-submission-step ${contractFileId ? 'completed' : contractError ? 'error' : 'loading'}`}>
                                        <div className='modern-step-indicator'>
                                            {contractFileId ? '✓' : contractError ? '✗' : '⏳'}
                                        </div>
                                        <div className='modern-step-content'>
                                            <span className='modern-step-title'>Final Contract</span>
                                            {contractError && <span className='modern-step-error'>{contractError}</span>}
                                        </div>
                                    </div>
                                }

                                {   prevailingWageFile &&
                                    <div className={`modern-submission-step ${prevailingWageFileId ? 'completed' : prevailingWageError ? 'error' : 'loading'}`}>
                                        <div className='modern-step-indicator'>
                                            {prevailingWageFileId ? '✓' : prevailingWageError ? '✗' : '⏳'}
                                        </div>
                                        <div className='modern-step-content'>
                                            <span className='modern-step-title'>Certified Payroll / Prevailing Wage Sheet</span>
                                            {prevailingWageError && <span className='modern-step-error'>{prevailingWageError}</span>}
                                        </div>
                                    </div>
                                }

                                {   bondFile &&
                                    <div className={`modern-submission-step ${bondFileId ? 'completed' : bondError ? 'error' : 'loading'}`}>
                                        <div className='modern-step-indicator'>
                                            {bondFileId ? '✓' : bondError ? '✗' : '⏳'}
                                        </div>
                                        <div className='modern-step-content'>
                                            <span className='modern-step-title'>Bonding Requirements</span>
                                            {bondError && <span className='modern-step-error'>{bondError}</span>}
                                        </div>
                                    </div>
                                }

                                {   taxExemptFile &&
                                    <div className={`modern-submission-step ${taxExemptFileId ? 'completed' : taxExemptError ? 'error' : 'loading'}`}>
                                        <div className='modern-step-indicator'>
                                            {taxExemptFileId ? '✓' : taxExemptError ? '✗' : '⏳'}
                                        </div>
                                        <div className='modern-step-content'>
                                            <span className='modern-step-title'>Tax Exempt Document</span>
                                            {taxExemptError && <span className='modern-step-error'>{taxExemptError}</span>}
                                        </div>
                                    </div>
                                }

                                {    certificateFile &&
                                    <div className={`modern-submission-step ${certificateFileId ? 'completed' : certificateError ? 'error' : 'loading'}`}>
                                        <div className='modern-step-indicator'>
                                            {certificateFileId ? '✓' : certificateError ? '✗' : '⏳'}
                                        </div>
                                        <div className='modern-step-content'>
                                            <span className='modern-step-title'>OCIP / CCIP Insurance Document</span>
                                            {certificateError && <span className='modern-step-error'>{certificateError}</span>}
                                        </div>
                                    </div>
                                }
                                {   financialTabFile &&
                                    <div className={`modern-submission-step ${financialTabFileId ? 'completed' : financialTabFileError ? 'error' : 'loading'}`}>
                                        <div className='modern-step-indicator'>
                                            {financialTabFileId ? '✓' : financialTabFileError ? '✗' : '⏳'}
                                        </div>
                                        <div className='modern-step-content'>
                                            <span className='modern-step-title'>Financial Tab Document</span>
                                            {financialTabFileError && <span className='modern-step-error'>{financialTabFileError}</span>}
                                        </div>
                                    </div>
                                }

                                {    taskFile &&
                                    <div className={`modern-submission-step ${taskFileId ? 'completed' : taskFileError ? 'error' : 'loading'}`}>
                                        <div className='modern-step-indicator'>
                                            {taskFileId ? '✓' : taskFileError ? '✗' : '⏳'}
                                        </div>
                                        <div className='modern-step-content'>
                                            <span className='modern-step-title'>Updated Task Budget File</span>
                                            {taskFileError && <span className='modern-step-error'>{taskFileError}</span>}
                                        </div>
                                    </div>
                                }

                                {    revenueFile &&
                                    <div className={`modern-submission-step ${revenueFileId ? 'completed' : revenueFileError ? 'error' : 'loading'}`}>
                                        <div className='modern-step-indicator'>
                                            {revenueFileId ? '✓' : revenueFileError ? '✗' : '⏳'}
                                        </div>
                                        <div className='modern-step-content'>
                                            <span className='modern-step-title'>Updated Revenue Budget File</span>
                                            {revenueFileError && <span className='modern-step-error'>{revenueFileError}</span>}
                                        </div>
                                    </div>
                                }

                                {    costFile &&
                                    <div className={`modern-submission-step ${costFileId ? 'completed' : costFileError ? 'error' : 'loading'}`}>
                                        <div className='modern-step-indicator'>
                                            {costFileId ? '✓' : costFileError ? '✗' : '⏳'}
                                        </div>
                                        <div className='modern-step-content'>
                                            <span className='modern-step-title'>Updated Cost Budget File</span>
                                            {costFileError && <span className='modern-step-error'>{costFileError}</span>}
                                        </div>
                                    </div>
                                }

                                {    serviceCostFile &&
                                    <div className={`modern-submission-step ${serviceFilesComplete ? 'completed' : serviceCostFileError ? 'error' : 'loading'}`}>
                                        <div className='modern-step-indicator'>
                                            {serviceFilesComplete ? '✓' : serviceCostFileError ? '✗' : '⏳'}
                                        </div>
                                        <div className='modern-step-content'>
                                            <span className='modern-step-title'>Service Cost Budget</span>
                                            {serviceCostFileError && <span className='modern-step-error'>{serviceCostFileError}</span>}
                                        </div>
                                    </div>
                                }

                                <div className={`modern-submission-step ${completeSubmission ? 'completed' : completionError ? 'error' : 'loading'}`}>
                                    <div className='modern-step-indicator'>
                                        {completeSubmission ? '✓' : completionError ? '✗' : '⏳'}
                                    </div>
                                    <div className='modern-step-content'>
                                        <span className='modern-step-title'>Project Booking Form</span>
                                        {completionError && <span className='modern-step-error'>{completionError}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {   completeSubmission &&
                            <div className='modern-submission-success'>
                                <div className='modern-success-icon'>🎉</div>
                                <h3 className='modern-success-title'>Success!</h3>
                                <p className='modern-success-message'>
                                    Your Project Booking Request has been submitted successfully.
                                </p>
                                <div className='modern-success-actions'>
                                    <button className='modern-success-button' onClick={() => window.location.reload()}>
                                        Close and Refresh
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    );
};

export default ProjectBooking;